(() => {
  // Ronde 60: de rekenregels hieronder (teksten, routes, ingrediënten,
  // buildPlan, variantGrams, preferredVariant) zijn ook de motor van het DIY
  // Lab in het nieuwe ontwerp (assets/n-lab.js, via window.azaDiyMotor). De
  // oude opbouw (init, start) draait alleen waar het oude Lab staat.
  const labs = document.querySelectorAll('[data-aza-diy-lab]');

  const COPY = {
    nl: {
      types_count: 'productroutes', steps_count: 'stappen', safety_pass: 'veiligheidscheck',
      step_use: 'Gebruik', step_type: 'Wat maak je?', step_profile: 'Jouw profiel', step_scent: 'Geur & grenzen', step_batch: 'Hoeveelheid',
      rail_note: 'De assistent bewaart niets. Je keuzes blijven alleen in deze pagina zolang je hem open hebt.',
      use_legend: 'Waar wil je het voor gebruiken?', use_help: 'Kies eerst het gebied. Daarna zie je alleen recepten die daarbij passen.',
      type_legend: 'Wat wil je maken?', type_help: 'Je ziet alleen opties die passen bij je keuze uit stap 1.',
      profile_legend: 'Waar moet het bij passen?', profile_help: 'We gebruiken dit om de basis en het tweede ingrediënt te kiezen.',
      goal_label: 'Hoofddoel', profile_label: 'Huid- of haarprofiel',
      scent_legend: 'Welke geur en welke grenzen?', scent_help: 'Geur is optioneel. Kies je een geur, dan zet het recept de etherische oliën er in een voorzichtige verdunning bij, met grammen en druppels.',
      mild_title: 'Extra mild', mild_help: 'Geen etherische olie in huid- of haarformules.',
      citrus_title: 'Citrus vermijden', citrus_help: 'Filter citroen, grapefruit en sinaasappel uit geursuggesties.',
      batch_legend: 'Hoeveel wil je maken?', batch_help: 'De formule rekent op gewicht. Bij een diffuserblend is dit de hoeveelheid mengvoorraad, niet de dosering voor het apparaat.',
      result_eyebrow: 'JOUW RECEPT', formula_title: 'Formule', method_title: 'Zo maak je het',
      products_title: 'Aza-producten voor dit recept', products_help: 'Ingrediënten uit de formule staan hieronder. Geursuggesties zijn optioneel. Externe benodigdheden staan in de formule maar niet in de winkelmand.',
      safety_title: 'Eerst controleren', missing: 'Kies eerst een optie om verder te gaan.',
      step_of: (n) => `Stap ${n} van 5`,
      ready: 'Recept klaar', limited: 'Nog niet beschikbaar',
      plan_for: (type) => `Jouw ${type.toLowerCase()}`,
      formula_note: 'Weeg op massa voor de meest consistente verhouding. Rond kleine batches af op de nauwkeurigheid van je weegschaal.',
      diffuser_note: 'Dit is de hoeveelheid blend om te bewaren. De verhouding is 2:1. Doseer de blend in je diffuser uitsluitend volgens de handleiding van het apparaat en de productinformatie.',
      no_formula: 'Voor deze productsoort geeft de assistent bewust geen compleet waterhoudend recept. Emulsie, conservering, pH en oplosbaarheid moeten als één formule worden gevalideerd.',
      optional_scent: 'Optionele geurrichting',
      product_link: 'Bekijk',
      used_in_formula: 'In de formule',
      optional_product: 'Optioneel',
      variant_unavailable: 'Niet beschikbaar',
      cart_busy: 'Recept toevoegen…',
      cart_success: (n) => `${n} product${n === 1 ? '' : 'en'} toegevoegd. Je kunt nu je winkelwagen bekijken.`,
      cart_partial: (a, b) => `${a} van ${b} producten toegevoegd. Niet-beschikbare producten zijn overgeslagen.`,
      cart_none: 'Geen van de gekozen producten is op dit moment direct beschikbaar om toe te voegen.',
      cart_error: 'Toevoegen lukte niet. Open de productlinks en voeg de producten afzonderlijk toe.',
      profile_general: 'Algemeen',
      no_scent: 'Zonder toegevoegde geur'
    },
    en: {
      types_count: 'product routes', steps_count: 'steps', safety_pass: 'safety pass',
      step_use: 'Use', step_type: 'What are you making?', step_profile: 'Your profile', step_scent: 'Scent & limits', step_batch: 'Amount',
      rail_note: 'The assistant stores nothing. Your choices stay only on this page while it is open.',
      use_legend: 'What do you want to use it for?', use_help: 'Choose the area first. You will only see recipes that fit it.',
      type_legend: 'What do you want to make?', type_help: 'You only see options that match your choice from step 1.',
      profile_legend: 'What should it suit?', profile_help: 'We use this to select the base and supporting ingredient.',
      goal_label: 'Main goal', profile_label: 'Skin or hair profile',
      scent_legend: 'Which scent and which limits?', scent_help: 'Scent is optional. If you choose one, the recipe adds the essential oils at a cautious dilution, in grams and drops.',
      mild_title: 'Extra mild', mild_help: 'No essential oil in skin or hair formulas.',
      citrus_title: 'Avoid citrus', citrus_help: 'Filter lemon, grapefruit and orange from scent suggestions.',
      batch_legend: 'How much do you want to make?', batch_help: 'Formulas are calculated by weight. For diffuser blends this is the amount of blend to store, not the dose for the device.',
      result_eyebrow: 'YOUR RECIPE', formula_title: 'Formula', method_title: 'How to make it',
      products_title: 'Aza products for this recipe', products_help: 'Formula ingredients are shown below. Scent suggestions are optional. External materials stay in the formula but are not added to the cart.',
      safety_title: 'Check first', missing: 'Choose an option before continuing.',
      step_of: (n) => `Step ${n} of 5`,
      ready: 'Recipe ready', limited: 'Not available yet',
      plan_for: (type) => `Your ${type.toLowerCase()}`,
      formula_note: 'Weigh by mass for the most consistent ratio. Round small batches to the precision of your scale.',
      diffuser_note: 'This is the amount of blend to store. The ratio is 2:1. Dose the blend in your diffuser only as directed by the device manual and product information.',
      no_formula: 'For this product type the assistant deliberately does not generate a complete water-based formula. Emulsion, preservation, pH and solubility need to be validated as one formula.',
      optional_scent: 'Optional scent direction',
      product_link: 'View',
      used_in_formula: 'In the formula',
      optional_product: 'Optional',
      variant_unavailable: 'Unavailable',
      cart_busy: 'Adding recipe…',
      cart_success: (n) => `${n} product${n === 1 ? '' : 's'} added. You can now view your cart.`,
      cart_partial: (a, b) => `${a} of ${b} products added. Unavailable products were skipped.`,
      cart_none: 'None of the selected products is currently available for direct add.',
      cart_error: 'Adding failed. Open the product links and add the products separately.',
      profile_general: 'General',
      no_scent: 'No added scent'
    }
  };
  COPY.de = Object.assign({}, COPY.en, {
    types_count: 'Produktrouten', steps_count: 'Schritte', safety_pass: 'Sicherheitscheck',
    step_use: 'Verwendung', step_type: 'Was stellst du her?', step_profile: 'Dein Profil', step_scent: 'Duft & Grenzen', step_batch: 'Menge',
    rail_note: 'Der Assistent speichert nichts. Deine Auswahl bleibt nur auf dieser Seite, solange sie geöffnet ist.',
    use_legend: 'Wofür möchtest du es verwenden?', use_help: 'Wähle zuerst den Bereich. Danach siehst du nur passende Rezepte.',
    type_legend: 'Was möchtest du herstellen?', type_help: 'Du siehst nur Optionen, die zu deiner Auswahl aus Schritt 1 passen.',
    profile_legend: 'Wozu soll es passen?', profile_help: 'Damit wählen wir Basis und unterstützende Zutat.',
    goal_label: 'Hauptziel', profile_label: 'Haut- oder Haarprofil',
    scent_legend: 'Welcher Duft und welche Grenzen?', scent_help: 'Duft ist optional. Wählst du einen Duft, setzt das Rezept die ätherischen Öle in vorsichtiger Verdünnung hinzu, in Gramm und Tropfen.',
    mild_title: 'Extra mild', mild_help: 'Keine ätherischen Öle in Haut- oder Haarformeln.',
    citrus_title: 'Zitrus vermeiden', citrus_help: 'Zitrone, Grapefruit und Orange aus Duftvorschlägen filtern.',
    batch_legend: 'Wie viel möchtest du herstellen?', batch_help: 'Formeln werden nach Gewicht berechnet. Bei Diffusermischungen ist dies die Menge zum Aufbewahren, nicht die Dosierung für das Gerät.',
    result_eyebrow: 'DEIN REZEPT', formula_title: 'Formel', method_title: 'So gehst du vor',
    products_title: 'Aza-Produkte für dieses Rezept', products_help: 'Die Zutaten der Formel stehen unten. Duftvorschläge sind optional. Externe Zutaten bleiben in der Formel, aber nicht im Warenkorb.',
    safety_title: 'Zuerst prüfen', missing: 'Wähle zuerst eine Option, bevor du fortfährst.',
    step_of: (n) => `Schritt ${n} von 5`, ready: 'Bereit zum Berechnen', limited: 'Zuerst Basis nötig',
    plan_for: (type) => `Dein Rezept: ${type}`,
    formula_note: 'Für ein möglichst gleichmäßiges Verhältnis nach Masse wiegen. Kleine Mengen auf die Genauigkeit deiner Waage runden.',
    diffuser_note: 'Dies ist die Menge der Mischung zum Aufbewahren. Das Verhältnis beträgt 2:1. Im Diffuser nur nach Geräteanleitung und Produktinformation dosieren.',
    no_formula: 'Für diesen Produkttyp erzeugt der Assistent bewusst keine vollständige wasserhaltige Formel. Emulsion, Konservierung, pH und Löslichkeit müssen als Gesamtsystem geprüft werden.',
    product_link: 'Ansehen', used_in_formula: 'In der Formel', optional_product: 'Optional',
    variant_unavailable: 'Nicht verfügbar',
    cart_busy: 'Rezept wird hinzugefügt…',
    cart_success: (n) => `${n} Produkt${n === 1 ? '' : 'e'} hinzugefügt. Du kannst jetzt den Warenkorb ansehen.`,
    cart_partial: (a, b) => `${a} von ${b} Produkten hinzugefügt. Nicht verfügbare Produkte wurden übersprungen.`,
    cart_none: 'Keines der ausgewählten Produkte ist derzeit direkt verfügbar.',
    cart_error: 'Hinzufügen fehlgeschlagen. Öffne die Produktlinks und füge die Produkte einzeln hinzu.',
    profile_general: 'Allgemein', no_scent: 'Ohne zusätzlichen Duft'
  });
  COPY.fr = Object.assign({}, COPY.en, {
    types_count: 'parcours produit', steps_count: 'étapes', safety_pass: 'contrôle sécurité',
    step_use: 'Usage', step_type: 'Que préparez-vous ?', step_profile: 'Votre profil', step_scent: 'Parfum & limites', step_batch: 'Quantité',
    rail_note: 'L’assistant ne stocke rien. Vos choix restent uniquement sur cette page tant qu’elle est ouverte.',
    use_legend: 'Pour quel usage ?', use_help: 'Choisissez d’abord la zone. Vous ne verrez ensuite que les recettes adaptées.',
    type_legend: 'Que souhaitez-vous préparer ?', type_help: 'Vous ne voyez que les options correspondant à votre choix de l’étape 1.',
    profile_legend: 'À quel profil doit-il convenir ?', profile_help: 'Nous utilisons ce choix pour sélectionner la base et l’ingrédient complémentaire.',
    goal_label: 'Objectif principal', profile_label: 'Profil peau ou cheveux',
    scent_legend: 'Quel parfum et quelles limites ?', scent_help: 'Le parfum est facultatif. Si vous en choisissez un, la recette ajoute les huiles essentielles à une dilution prudente, en grammes et en gouttes.',
    mild_title: 'Extra doux', mild_help: 'Aucune huile essentielle dans les formules peau ou cheveux.',
    citrus_title: 'Éviter les agrumes', citrus_help: 'Retirer citron, pamplemousse et orange des suggestions parfumées.',
    batch_legend: 'Quelle quantité souhaitez-vous préparer ?', batch_help: 'Les formules sont calculées au poids. Pour un mélange diffuseur, il s’agit de la quantité à conserver, pas de la dose pour l’appareil.',
    result_eyebrow: 'VOTRE RECETTE', formula_title: 'Formule', method_title: 'Préparation',
    products_title: 'Produits Aza pour cette recette', products_help: 'Les ingrédients de la formule sont ci-dessous. Les suggestions de parfum sont facultatives. Les ingrédients externes ne sont pas ajoutés au panier.',
    safety_title: 'À vérifier d’abord', missing: 'Choisissez d’abord une option avant de continuer.',
    step_of: (n) => `Étape ${n} sur 5`, ready: 'Prêt à calculer', limited: 'Base requise d’abord',
    plan_for: (type) => `Votre recette : ${type.toLowerCase()}`,
    formula_note: 'Pesez en masse pour obtenir le ratio le plus régulier. Arrondissez les petites quantités selon la précision de votre balance.',
    diffuser_note: 'Il s’agit de la quantité de mélange à conserver. Le ratio est de 2:1. Dosez dans le diffuseur selon sa notice et les informations produit.',
    no_formula: 'Pour ce type de produit, l’assistant ne génère volontairement pas de formule aqueuse complète. Émulsion, conservation, pH et solubilité doivent être validés comme un ensemble.',
    product_link: 'Voir', used_in_formula: 'Dans la formule', optional_product: 'Optionnel',
    variant_unavailable: 'Indisponible',
    cart_busy: 'Ajout de la recette…',
    cart_success: (n) => `${n} produit${n === 1 ? '' : 's'} ajouté${n === 1 ? '' : 's'}. Vous pouvez maintenant voir le panier.`,
    cart_partial: (a, b) => `${a} produit(s) sur ${b} ajouté(s). Les produits indisponibles ont été ignorés.`,
    cart_none: 'Aucun des produits sélectionnés n’est actuellement disponible pour un ajout direct.',
    cart_error: 'L’ajout a échoué. Ouvrez les liens produit et ajoutez les articles séparément.',
    profile_general: 'Général', no_scent: 'Sans parfum ajouté'
  });

  // Upgrade oktober 2026: teksten voor de stappenbalk, de receptkaart en de
  // boodschappenkaart. Ontbrekende talen vallen terug op Engels.
  const UI = {
    nl: {
      step_short: ['Gebruik', 'Product', 'Profiel', 'Geur', 'Hoeveelheid'],
      card_eyebrow: 'Jouw recept', card_title_empty: 'Nog niets gekozen', ratio_live: 'Verhouding',
      result_eyebrow: 'Jouw recept', products_title: 'Wat je nodig hebt', optional_title: 'Optioneel erbij',
      total_label: 'Totaal', external: 'Zelf erbij:', unavailable: 'Nu niet leverbaar', added: 'Toegevoegd',
      parts_one: 'deel', parts_many: 'delen', for_batch: (b) => `Voor ${b} g`, view: 'Bekijk',
      drops: (n) => `≈ ${n} ${n === 1 ? 'druppel' : 'druppels'}`, prep: (m) => `Voorbereiding ${m} min`,
      level_beginner: 'Niveau: beginner', level_gemiddeld: 'Niveau: gemiddeld',
      have_it: 'Vink uit wat je al in huis hebt.', replaces: (name) => `in plaats van ${name} (zelfde plant)`
    },
    en: {
      step_short: ['Use', 'Product', 'Profile', 'Scent', 'Amount'],
      card_eyebrow: 'Your recipe', card_title_empty: 'Nothing chosen yet', ratio_live: 'Ratio',
      result_eyebrow: 'Your recipe', products_title: 'What you need', optional_title: 'Optional extras',
      total_label: 'Total', external: 'Bring yourself:', unavailable: 'Currently unavailable', added: 'Added',
      parts_one: 'part', parts_many: 'parts', for_batch: (b) => `For ${b} g`, view: 'View',
      drops: (n) => `≈ ${n} ${n === 1 ? 'drop' : 'drops'}`, prep: (m) => `Prep ${m} min`,
      level_beginner: 'Level: beginner', level_gemiddeld: 'Level: intermediate',
      have_it: 'Untick what you already have.', replaces: (name) => `instead of ${name} (same plant)`
    },
    de: {
      step_short: ['Verwendung', 'Produkt', 'Profil', 'Duft', 'Menge'],
      card_eyebrow: 'Dein Rezept', card_title_empty: 'Noch nichts gewählt', ratio_live: 'Verhältnis',
      result_eyebrow: 'Dein Rezept', products_title: 'Was du brauchst', optional_title: 'Optional dazu',
      total_label: 'Summe', external: 'Selbst besorgen:', unavailable: 'Derzeit nicht lieferbar', added: 'Hinzugefügt',
      parts_one: 'Teil', parts_many: 'Teile', for_batch: (b) => `Für ${b} g`, view: 'Ansehen',
      drops: (n) => `≈ ${n} ${n === 1 ? 'Tropfen' : 'Tropfen'}`, prep: (m) => `Vorbereitung ${m} Min.`,
      level_beginner: 'Niveau: Anfänger', level_gemiddeld: 'Niveau: mittel',
      have_it: 'Entferne das Häkchen bei allem, was du schon hast.', replaces: (name) => `statt ${name} (gleiche Pflanze)`
    },
    fr: {
      step_short: ['Usage', 'Produit', 'Profil', 'Parfum', 'Quantité'],
      card_eyebrow: 'Votre recette', card_title_empty: 'Rien de choisi', ratio_live: 'Proportions',
      result_eyebrow: 'Votre recette', products_title: 'Ce qu’il vous faut', optional_title: 'En option',
      total_label: 'Total', external: 'À prévoir vous-même :', unavailable: 'Actuellement indisponible', added: 'Ajouté',
      parts_one: 'part', parts_many: 'parts', for_batch: (b) => `Pour ${b} g`, view: 'Voir',
      drops: (n) => `≈ ${n} ${n === 1 ? 'goutte' : 'gouttes'}`, prep: (m) => `Préparation ${m} min`,
      level_beginner: 'Niveau : débutant', level_gemiddeld: 'Niveau : intermédiaire',
      have_it: 'Décochez ce que vous avez déjà.', replaces: (name) => `à la place de ${name} (même plante)`
    }
  };
  Object.keys(COPY).forEach((lang) => { COPY[lang] = Object.assign({}, COPY[lang], UI.en, UI[lang] || {}); });

  const EXTRA_LABELS = {
    de: {
      'face-oil':'Gesichtsöl','body-oil':'Körperöl','hair-oil':'Haaröl','body-butter':'Body Butter','lotion-bar':'Feste Lotion','lip-balm':'Lippenbalsam',
      'face-mask':'Gesichtsmaske','face-scrub':'Gesichtspeeling','body-mask':'Körpermaske','hair-mask':'Haarmaske','hair-wash':'Shampoo / Haarwaschmix',
      'dry-shampoo':'Trockenshampoo','conditioner':'Conditioner / Pre-Wash','body-scrub':'Körperpeeling','bath-mix':'Bad- oder Fußbadmix',
      'soap-base':'Seife aus Seifenbasis','shower-gel':'Duschgel','diffuser':'Diffusermischung','cream':'Creme / Lotion','room-spray':'Raumspray',
      nourish:'Nährend & reichhaltig',light:'Leicht & einfach',soft:'Weich & geschmeidig',cleanse:'Reinigen & erfrischen',ritual:'Ritual & Dufterlebnis',simple:'So wenige Zutaten wie möglich',
      dry:'Trocken',balanced:'Normal / ausgeglichen',oily:'Leichtes Hautgefühl gewünscht',sensitive:'Empfindliche Routine',
      'hair-dry':'Trockenes oder geschädigtes Haar','hair-curly':'Locken / dickes Haar','hair-fine':'Feines Haar',scalp:'Kopfhaut + Längen',general:'Allgemeine Anwendung',
      none:'Ohne Duft',fresh:'Frisch',floral:'Blumig',herbal:'Kräuterig-grün',woody:'Holzig',warm:'Warm & rund'
    },
    fr: {
      'face-oil':'Huile visage','body-oil':'Huile corps','hair-oil':'Huile cheveux','body-butter':'Beurre corporel','lotion-bar':'Lotion solide','lip-balm':'Baume à lèvres',
      'face-mask':'Masque visage','face-scrub':'Gommage visage','body-mask':'Masque corps','hair-mask':'Masque cheveux','hair-wash':'Shampooing / lavage cheveux',
      'dry-shampoo':'Shampooing sec','conditioner':'Après-shampooing / pré-lavage','body-scrub':'Gommage corps','bath-mix':'Mélange bain ou bain de pieds',
      'soap-base':'Savon sur base à fondre','shower-gel':'Gel douche','diffuser':'Mélange diffuseur','cream':'Crème / lotion','room-spray':'Spray d’ambiance',
      nourish:'Nourrissant & riche',light:'Léger & simple',soft:'Doux & souple',cleanse:'Nettoyer & rafraîchir',ritual:'Rituel & parfum',simple:'Le moins d’ingrédients possible',
      dry:'Sèche',balanced:'Normale / équilibrée',oily:'Toucher léger souhaité',sensitive:'Routine sensible',
      'hair-dry':'Cheveux secs ou abîmés','hair-curly':'Boucles / cheveux épais','hair-fine':'Cheveux fins',scalp:'Cuir chevelu + longueurs',general:'Usage général',
      none:'Sans parfum',fresh:'Frais',floral:'Floral',herbal:'Herbacé',woody:'Boisé',warm:'Chaud & rond'
    }
  };

  const USES = [
    { id: 'skin', groups: ['skin'], labels: { nl: 'Huid', en: 'Skin', de: 'Haut', fr: 'Peau' }, help: { nl: 'Gezichtsolie, masker of balsem', en: 'Face oil, mask or balm', de: 'Gesichtsöl, Maske oder Balsam', fr: 'Huile visage, masque ou baume' } },
    { id: 'body', groups: ['body','bath'], labels: { nl: 'Lichaam', en: 'Body', de: 'Körper', fr: 'Corps' }, help: { nl: 'Olie, butter, scrub, bad of zeep', en: 'Oil, butter, scrub, bath or soap', de: 'Öl, Butter, Peeling, Bad oder Seife', fr: 'Huile, beurre, gommage, bain ou savon' } },
    { id: 'hair', groups: ['hair'], labels: { nl: 'Haar', en: 'Hair', de: 'Haare', fr: 'Cheveux' }, help: { nl: 'Olie, masker, haarwas of conditioner', en: 'Oil, mask, hair wash or conditioner', de: 'Öl, Maske, Haarwäsche oder Conditioner', fr: 'Huile, masque, lavage ou après-shampooing' } },
    { id: 'scent', groups: ['home'], labels: { nl: 'Geur', en: 'Scent', de: 'Duft', fr: 'Parfum' }, help: { nl: 'Diffuserblend of kamerspray', en: 'Diffuser blend or room spray', de: 'Diffusermischung oder Raumspray', fr: 'Mélange diffuseur ou spray d’ambiance' } }
  ];

  const TYPES = [
    { id: 'face-oil', group: 'skin', ready: true, labels: { nl: 'Gezichtsolie', en: 'Face oil' }, help: { nl: 'Lichte of voedende draagoliemix', en: 'Light or nourishing carrier-oil blend' } },
    { id: 'body-oil', group: 'body', ready: true, labels: { nl: 'Lichaamsolie', en: 'Body oil' }, help: { nl: 'Watervrije olieblend', en: 'Water-free oil blend' } },
    { id: 'hair-oil', group: 'hair', ready: true, labels: { nl: 'Haarolie', en: 'Hair oil' }, help: { nl: 'Voor lengtes, punten of pre-wash', en: 'For lengths, ends or pre-wash use' } },
    { id: 'body-butter', group: 'body', ready: true, labels: { nl: 'Body butter', en: 'Body butter' }, help: { nl: 'Watervrij, boter + olie', en: 'Water-free butter and oil' } },
    { id: 'lotion-bar', group: 'body', ready: true, labels: { nl: 'Vaste lotion', en: 'Lotion bar' }, help: { nl: 'Bijenwas, boter en olie, smelt op je huid', en: 'Beeswax, butter and oil that melts on your skin' } },
    { id: 'lip-balm', group: 'skin', ready: true, labels: { nl: 'Lippenbalsem', en: 'Lip balm' }, help: { nl: 'Boter, olie en bijenwas', en: 'Butter, oil and beeswax' } },
    { id: 'face-mask', group: 'skin', ready: true, labels: { nl: 'Gezichtsmasker', en: 'Face mask' }, help: { nl: 'Droge kleimix, vers aanmaken', en: 'Dry clay blend, mix fresh' } },
    { id: 'face-scrub', group: 'skin', ready: false, labels: { nl: 'Gezichtsscrub', en: 'Face scrub' }, help: { nl: 'Vraagt een geteste milde basis', en: 'Needs a tested gentle base' } },
    { id: 'body-mask', group: 'body', ready: true, labels: { nl: 'Lichaamsmasker', en: 'Body mask' }, help: { nl: 'Droge kleimix, vers aanmaken', en: 'Dry clay blend, mix fresh' } },
    { id: 'hair-mask', group: 'hair', ready: true, labels: { nl: 'Haarmasker', en: 'Hair mask' }, help: { nl: 'Oliebehandeling voor het wassen', en: 'Oil treatment before washing' } },
    { id: 'hair-wash', group: 'hair', ready: true, labels: { nl: 'Shampoo / haarwasmix', en: 'Shampoo / hair wash mix' }, help: { nl: 'Droge kruiden- en kleimix', en: 'Dry botanical and clay wash mix' } },
    { id: 'dry-shampoo', group: 'hair', ready: true, labels: { nl: 'Droge shampoo', en: 'Dry shampoo' }, help: { nl: 'Droge poedermix voor de haarwortel', en: 'Dry powder blend for roots' } },
    { id: 'conditioner', group: 'hair', ready: true, labels: { nl: 'Conditioner / pre-wash', en: 'Conditioner / pre-wash' }, help: { nl: 'Watervrije verzorgingsmix', en: 'Water-free conditioning blend' } },
    { id: 'body-scrub', group: 'body', ready: true, labels: { nl: 'Lichaamsscrub', en: 'Body scrub' }, help: { nl: 'Zout + verzorgende olie', en: 'Salt and conditioning oil' } },
    { id: 'bath-mix', group: 'bath', ready: true, labels: { nl: 'Bad- of voetenbadmix', en: 'Bath or foot-soak mix' }, help: { nl: 'Minerale zoutmix', en: 'Mineral salt blend' } },
    { id: 'soap-base', group: 'bath', ready: true, labels: { nl: 'Zeep op zeepbasis', en: 'Melt-and-pour soap' }, help: { nl: 'Geen loogberekening nodig', en: 'No lye calculation needed' } },
    { id: 'shower-gel', group: 'bath', ready: false, labels: { nl: 'Douchegel', en: 'Shower gel' }, help: { nl: 'Vraagt surfactant + conserveringssysteem', en: 'Needs surfactant and preservation system' } },
    { id: 'diffuser', group: 'home', ready: true, labels: { nl: 'Diffuserblend', en: 'Diffuser blend' }, help: { nl: 'Geurverhouding in delen', en: 'Scent ratio in parts' } },
    { id: 'cream', group: 'skin', ready: false, labels: { nl: 'Crème / lotion', en: 'Cream / lotion' }, help: { nl: 'Vraagt emulsie + conservering', en: 'Needs emulsion and preservation' } },
    { id: 'room-spray', group: 'home', ready: true, labels: { nl: 'Kamerspray', en: 'Room spray' }, help: { nl: 'Alcoholbasis + hydrosol + geurblend', en: 'Alcohol base, hydrosol and scent blend' } }
  ];

  // Voorbereidingstijd (minuten, zonder afkoelen of rusten) en niveau per route.
  const TYPE_META = {
    'face-oil': [5, 'beginner'], 'body-oil': [5, 'beginner'], 'hair-oil': [5, 'beginner'], 'hair-mask': [5, 'beginner'],
    'conditioner': [5, 'beginner'], 'body-butter': [40, 'gemiddeld'], 'lotion-bar': [30, 'beginner'], 'lip-balm': [30, 'beginner'], 'face-mask': [5, 'beginner'],
    'body-mask': [5, 'beginner'], 'hair-wash': [5, 'beginner'], 'dry-shampoo': [5, 'beginner'], 'body-scrub': [10, 'beginner'],
    'bath-mix': [5, 'beginner'], 'soap-base': [45, 'gemiddeld'], 'diffuser': [2, 'beginner'], 'room-spray': [10, 'beginner']
  };

  // Voorzichtige totale verdunning van etherische olie per route, in procent
  // van de batch. Gezicht en dicht bij het gezicht lager, lippen het laagst.
  const SCENT_PCT = {
    'face-oil': 0.5, 'lip-balm': 0.25, 'face-mask': 0.5, 'dry-shampoo': 0.5, 'hair-wash': 0.5,
    'body-oil': 1, 'body-butter': 1, 'lotion-bar': 1, 'hair-oil': 1, 'hair-mask': 1, 'conditioner': 1,
    'body-mask': 1, 'body-scrub': 1, 'bath-mix': 1, 'soap-base': 1
  };

  // Alleen echte gelijken: zelfde plant, ander productnaam.
  const ALTERNATIVES = { reetha: 'soapnut', soapnut: 'reetha' };

  // Ongeveer 25 druppels per gram etherische olie; alleen als richtgetal.
  const dropsFor = (grams) => Math.max(1, Math.round(grams * 25));

  const GOALS = [
    { id: 'nourish', labels: { nl: 'Voedend & rijk', en: 'Nourishing & rich' }, groups: ['skin','body','hair'] },
    { id: 'light', labels: { nl: 'Licht & eenvoudig', en: 'Light & simple' }, groups: ['skin','body','hair'] },
    { id: 'soft', labels: { nl: 'Zacht & soepel', en: 'Soft & smooth' }, groups: ['skin','body','hair'] },
    { id: 'cleanse', labels: { nl: 'Reinigen & opfrissen', en: 'Cleanse & refresh' }, groups: ['skin','hair','bath','home'] },
    { id: 'ritual', labels: { nl: 'Ritueel & geurbeleving', en: 'Ritual & scent' }, groups: ['body','bath','home'] },
    { id: 'simple', labels: { nl: 'Zo min mogelijk ingrediënten', en: 'As few ingredients as possible' }, groups: ['skin','body','hair','bath','home'] }
  ];

  const PROFILES = [
    { id: 'dry', labels: { nl: 'Droog', en: 'Dry' }, groups: ['skin','body'] },
    { id: 'balanced', labels: { nl: 'Normaal / in balans', en: 'Balanced' }, groups: ['skin','body'] },
    { id: 'oily', labels: { nl: 'Licht gevoel gewenst', en: 'Prefer a light feel' }, groups: ['skin'] },
    { id: 'sensitive', labels: { nl: 'Gevoelige routine', en: 'Sensitive routine' }, groups: ['skin','body'] },
    { id: 'hair-dry', labels: { nl: 'Droog of beschadigd haar', en: 'Dry or damaged hair' }, groups: ['hair'] },
    { id: 'hair-curly', labels: { nl: 'Krullen / dik haar', en: 'Curly / thick hair' }, groups: ['hair'] },
    { id: 'hair-fine', labels: { nl: 'Fijn haar', en: 'Fine hair' }, groups: ['hair'] },
    { id: 'scalp', labels: { nl: 'Hoofdhuid + lengtes', en: 'Scalp and lengths' }, groups: ['hair'] },
    { id: 'general', labels: { nl: 'Algemeen gebruik', en: 'General use' }, groups: ['bath','home'] }
  ];

  const SCENTS = [
    { id: 'none', labels: { nl: 'Zonder geur', en: 'No added scent' }, help: { nl: 'Minst complex', en: 'Least complex' } },
    { id: 'fresh', labels: { nl: 'Fris', en: 'Fresh' }, help: { nl: 'Citrus of koel', en: 'Citrus or cool' } },
    { id: 'floral', labels: { nl: 'Bloemig', en: 'Floral' }, help: { nl: 'Lavendel / geranium', en: 'Lavender / geranium' } },
    { id: 'herbal', labels: { nl: 'Kruidig groen', en: 'Herbal green' }, help: { nl: 'Rozemarijn / tea tree', en: 'Rosemary / tea tree' } },
    { id: 'woody', labels: { nl: 'Houtachtig', en: 'Woody' }, help: { nl: 'Ceder / wierook', en: 'Cedar / frankincense' } },
    { id: 'warm', labels: { nl: 'Warm & rond', en: 'Warm & rounded' }, help: { nl: 'Ylang ylang / sinaasappel', en: 'Ylang ylang / orange' } }
  ];

  const ING = {
    jojoba: { name: { nl: 'Jojoba olie', en: 'Jojoba oil' }, handle: 'jojoba-olie' },
    argan: { name: { nl: 'Cosmetische arganolie', en: 'Cosmetic argan oil' }, handle: 'cosmetische-arganolie' },
    avocado: { name: { nl: 'Avocado olie', en: 'Avocado oil' }, handle: 'avocado-olie' },
    grapeseed: { name: { nl: 'Druivenpitolie', en: 'Grapeseed oil' }, handle: 'druivenpit-olie' },
    hemp: { name: { nl: 'Hennepzaadolie', en: 'Hemp seed oil' }, handle: 'hennepzaad-olie' },
    calendula: { name: { nl: 'Calendula olie', en: 'Calendula oil' }, handle: 'calendula-olie-biologisch' },
    rosehip: { name: { nl: 'Rozenbottelolie', en: 'Rosehip oil' }, handle: '100-biologische-rozenbottel-olie' },
    moringa: { name: { nl: 'Moringa olie', en: 'Moringa oil' }, handle: 'moringa-olie' },
    broccoli: { name: { nl: 'Broccolizaadolie', en: 'Broccoli seed oil' }, handle: 'broccolizaad-olie' },
    batana: { name: { nl: 'Batanaolie', en: 'Batana oil' }, handle: 'batana-olie' },
    castor: { name: { nl: 'Castorolie', en: 'Castor oil' }, handle: 'castor-olie' },
    shea: { name: { nl: 'Raw sheaboter', en: 'Raw shea butter' }, handle: 'raw-sheaboter' },
    cocoa: { name: { nl: 'Cacaoboter', en: 'Cocoa butter' }, handle: 'cacao-boter' },
    mango: { name: { nl: 'Mangoboter', en: 'Mango butter' }, handle: 'mango-boter-200-gram' },
    beeswax: { name: { nl: 'Gele bijenwas', en: 'Yellow beeswax' }, handle: 'bijenwas' },
    whiteClay: { name: { nl: 'Witte klei', en: 'White clay' }, handle: 'witte-klei-poeder' },
    greenClay: { name: { nl: 'Groene klei', en: 'Green clay' }, handle: 'groene-klei-poeder' },
    ghassoul: { name: { nl: 'Ghassoul poeder', en: 'Ghassoul clay' }, handle: 'ghassoul-poeder' },
    multani: { name: { nl: 'Multani mitti', en: 'Multani mitti' }, handle: 'multani-mitti-poeder' },
    reetha: { name: { nl: 'Reetha poeder', en: 'Reetha powder' }, handle: 'reetha-poeder' },
    soapnut: { name: { nl: 'Zeepnoten poeder', en: 'Soapnut powder' }, handle: 'zeepnoten-poeder' },
    epsom: { name: { nl: 'Bitterzout / Epsomzout', en: 'Epsom salt' }, handle: 'bitterzout-magnesiumsulfaat-epsomzout' },
    deadSeaFine: { name: { nl: 'Dode Zee zout fijn', en: 'Fine Dead Sea salt' }, handle: 'dode-zee-zout-kristal-fijn' },
    perfumersAlcohol: { name: { nl: 'Parfumeursalcohol 95-96%', en: 'Perfumers alcohol 95-96%', de: 'Parfümeursalkohol 95-96%', fr: 'Alcool de parfumerie 95-96%' }, external: true },
    lavenderWater: { name: { nl: 'Lavendelwater', en: 'Lavender water' }, handle: 'lavendel-water' },
    geraniumWater: { name: { nl: 'Geraniumwater', en: 'Geranium water' }, handle: 'geranium-water' },
    neroliWater: { name: { nl: 'Neroliwater', en: 'Neroli water' }, handle: 'neroli-water' },
    peppermintWater: { name: { nl: 'Pepermuntwater', en: 'Peppermint water' }, handle: 'pepermunt-water' },
    soapShea: { name: { nl: 'Zeepbasis sheaboter', en: 'Shea soap base' }, handle: 'zeepbasis-sheaboter-1-kg' },
    soapOlive: { name: { nl: 'Zeepbasis olijfolie', en: 'Olive oil soap base' }, handle: 'zeepbasis-olijfolie-1-kg' },
    soapOat: { name: { nl: 'Zeepbasis havermout', en: 'Oat soap base' }, handle: 'zeepbasis-havermout-1-kg' },
    soapTea: { name: { nl: 'Zeepbasis theeboom', en: 'Tea tree soap base' }, handle: 'zeepbasis-theeboom-1-kg' },
    eoLavender: { name: { nl: 'Lavendel etherische olie', en: 'Lavender essential oil' }, handle: 'lavendel-essentiele-olie', eo: true },
    eoGeranium: { name: { nl: 'Geranium etherische olie', en: 'Geranium essential oil' }, handle: 'geranium-essentiele-olie', eo: true },
    eoRosemary: { name: { nl: 'Rozemarijn etherische olie', en: 'Rosemary essential oil' }, handle: 'rozemarijn-essentiele-olie', eo: true },
    eoTeaTree: { name: { nl: 'Tea tree etherische olie', en: 'Tea tree essential oil' }, handle: 'tea-tree-essentiele-olie', eo: true },
    eoCedar: { name: { nl: 'Ceder etherische olie', en: 'Cedar essential oil' }, handle: 'ceder-essentiele-olie', eo: true },
    eoFrank: { name: { nl: 'Wierook etherische olie', en: 'Frankincense essential oil' }, handle: 'wierook-essentiele-olie', eo: true },
    eoLemon: { name: { nl: 'Citroen etherische olie', en: 'Lemon essential oil' }, handle: 'citroen-essentiele-olie', eo: true, citrus: true },
    eoGrapefruit: { name: { nl: 'Grapefruit etherische olie', en: 'Grapefruit essential oil' }, handle: 'grapefruit-essentiele-olie', eo: true, citrus: true },
    eoOrange: { name: { nl: 'Sinaasappel etherische olie', en: 'Orange essential oil' }, handle: 'sinaasappel-essentiele-olie', eo: true, citrus: true },
    eoPeppermint: { name: { nl: 'Pepermunt etherische olie', en: 'Peppermint essential oil' }, handle: 'pepermunt-essentiele-olie', eo: true },
    eoEucalyptus: { name: { nl: 'Eucalyptus etherische olie', en: 'Eucalyptus essential oil' }, handle: 'eucalyptus-essentiele-olie', eo: true },
    eoYlang: { name: { nl: 'Ylang ylang etherische olie', en: 'Ylang ylang essential oil' }, handle: 'ylang-ylang-essentiele-olie', eo: true }
  };

  const nameOf = (item, locale) => item?.name?.[locale] || item?.name?.en || '';
  const labelOf = (item, locale) => item?.labels?.[locale] || EXTRA_LABELS[locale]?.[item?.id] || item?.labels?.en || '';
  const helpOf = (item, locale) => item?.help?.[locale] || item?.help?.en || '';

  const carrierPair = (profile, goal) => {
    if (profile === 'dry') return ['argan', goal === 'light' ? 'jojoba' : 'avocado'];
    if (profile === 'oily') return ['jojoba', goal === 'nourish' ? 'argan' : 'grapeseed'];
    if (profile === 'sensitive') return ['jojoba', 'calendula'];
    if (profile === 'hair-dry') return ['argan', 'avocado'];
    if (profile === 'hair-curly') return ['batana', 'argan'];
    if (profile === 'hair-fine') return ['broccoli', 'jojoba'];
    if (profile === 'scalp') return ['jojoba', 'castor'];
    return goal === 'nourish' ? ['argan', 'moringa'] : ['jojoba', 'grapeseed'];
  };

  const clayPair = (profile, goal) => {
    if (profile === 'sensitive' || profile === 'dry') return ['whiteClay', 'ghassoul'];
    if (profile === 'oily' || goal === 'cleanse') return ['greenClay', 'ghassoul'];
    return ['ghassoul', 'whiteClay'];
  };

  const hydrosol = (profile) => {
    if (profile === 'sensitive') return 'lavenderWater';
    if (profile === 'oily') return 'peppermintWater';
    if (profile === 'dry') return 'geraniumWater';
    return 'neroliWater';
  };

  const soapBase = (profile, goal) => {
    if (profile === 'sensitive') return 'soapOat';
    if (profile === 'dry' || goal === 'nourish') return 'soapShea';
    if (goal === 'cleanse') return 'soapTea';
    return 'soapOlive';
  };

  const scentKeys = (scent, avoidCitrus) => {
    if (scent === 'floral') return ['eoLavender', 'eoGeranium'];
    if (scent === 'herbal') return ['eoRosemary', 'eoTeaTree'];
    if (scent === 'woody') return ['eoCedar', 'eoFrank'];
    if (scent === 'warm') return avoidCitrus ? ['eoYlang', 'eoCedar'] : ['eoYlang', 'eoOrange'];
    if (scent === 'fresh') return avoidCitrus ? ['eoPeppermint', 'eoEucalyptus'] : ['eoGrapefruit', 'eoLemon'];
    return [];
  };

  const fmt = (value, locale) => new Intl.NumberFormat({ nl: 'nl-NL', de: 'de-DE', fr: 'fr-FR' }[locale] || 'en-GB', { maximumFractionDigits: 2 }).format(value);
  const productVariantCache = new Map();

  async function getPurchasableVariants(handle) {
    if (productVariantCache.has(handle)) return productVariantCache.get(handle);

    const request = (async () => {
      const rootPath = window.Shopify?.routes?.root || '/';

      try {
        const response = await fetch(`${rootPath}products/${encodeURIComponent(handle)}?view=quick-view`, {
          headers: { Accept: 'text/html' }
        });
        if (response.ok) {
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const variantsNode = doc.querySelector('product-variants script[type="application/json"]:not([data-aza-strict-inventory])');
          const inventoryNode = doc.querySelector('[data-aza-strict-inventory]');

          if (variantsNode && inventoryNode) {
            const variants = JSON.parse(variantsNode.textContent || '[]');
            const inventory = JSON.parse(inventoryNode.textContent || '[]');
            const inventoryById = new Map(inventory.map((item) => [Number(item.id), item]));
            return variants.filter((variant) => {
              if (!variant.available) return false;
              const stock = inventoryById.get(Number(variant.id));
              if (!stock) return false;
              return !stock.tracked || Number(stock.quantity) > 0;
            });
          }
        }
      } catch (error) {
        // Gebruik hieronder de Shopify product-JSON als robuuste fallback.
      }

      try {
        const fallback = await fetch(`${rootPath}products/${encodeURIComponent(handle)}.js`, {
          headers: { Accept: 'application/json' }
        });
        if (!fallback.ok) return [];
        const product = await fallback.json();
        return (product.variants || []).filter((variant) => variant.available);
      } catch (error) {
        return [];
      }
    })();

    productVariantCache.set(handle, request);
    return request;
  }

  // Inhoud van een variant in gram ('3x 30 ml' wordt 72 g), dezelfde rekenwijze
  // als het receptblok (aza-recipes.js): ml telt voorzichtig als 0,8 g.
  function variantGrams(variant) {
    const title = String(variant.title || '').toLowerCase();
    const match = title.match(/(?:(\d+)\s*[x×]\s*)?(\d+(?:[.,]\d+)?)\s*(kg|gr|gram|g|ml|milliliter|l)\b/i);
    if (!match) return null;
    const size = Number(match[2].replace(',', '.')) * Number(match[1] || 1);
    const unit = match[3].toLowerCase();
    if (unit === 'kg') return size * 1000;
    if (unit === 'l') return size * 800;
    if (unit === 'ml' || unit === 'milliliter') return size * 0.8;
    return size;
  }

  // Met een benodigde hoeveelheid: de goedkoopste verpakking met genoeg
  // inhoud, bij gelijke prijs de kleinste; heeft geen enkele genoeg, dan de
  // grootste. Zonder hoeveelheid of bekende inhoud: de kleinste losse.
  function preferredVariant(variants, needed = 0) {
    if (!variants.length) return null;
    if (needed > 0) {
      const known = variants.map((variant) => ({ variant, grams: variantGrams(variant) })).filter((x) => x.grams !== null);
      const enough = known.filter((x) => x.grams >= needed)
        .sort((a, b) => Number(a.variant.price) - Number(b.variant.price) || a.grams - b.grams)[0];
      if (enough) return enough.variant;
      if (known.length) return known.sort((a, b) => b.grams - a.grams)[0].variant;
    }

    const score = (variant, index) => {
      const title = String(variant.title || '').toLowerCase();
      if (!title || title === 'default title') return index;

      const packMatch = title.match(/(?:^|\s)(\d+)\s*x\s*/i);
      const packCount = packMatch ? Number(packMatch[1]) : 1;
      const amountMatch = title.match(/(\d+(?:[.,]\d+)?)\s*(ml|milliliter|g|gr|gram|kg|l)(?:\b|$)/i);
      let amount = 100000;
      if (amountMatch) {
        amount = Number(amountMatch[1].replace(',', '.'));
        const unit = amountMatch[2].toLowerCase();
        if (unit === 'kg' || unit === 'l') amount *= 1000;
      }

      const multipackPenalty = packCount > 1 ? 1000000 + (packCount * 10000) : 0;
      return multipackPenalty + amount + (index / 1000);
    };

    return variants
      .map((variant, index) => ({ variant, score: score(variant, index) }))
      .sort((a, b) => a.score - b.score)[0].variant;
  }

  // Varianten: 'photo' (stap 1, met beeld), 'card' (titel + uitleg) en 'chip'
  // (alleen een label). De radio blijft de echte bron, dus toetsenbord en
  // schermlezer werken als bij een gewone radiogroep.
  function makeChoice(name, value, label, help, checked = false, variant = 'card', image = '') {
    const el = document.createElement('label');
    el.className = `aza-diy-choice aza-diy-choice--${variant}`;
    const input = document.createElement('input');
    input.type = 'radio';
    input.name = name;
    input.value = value;
    input.checked = checked;
    const body = document.createElement('span');
    body.className = 'aza-diy-choice__body';
    if (variant === 'photo' && image) {
      const media = document.createElement('span');
      media.className = 'aza-diy-choice__media';
      const img = document.createElement('img');
      img.src = image;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 640;
      img.height = 480;
      media.append(img);
      body.append(media);
    }
    const text = document.createElement('span');
    text.className = 'aza-diy-choice__text';
    const strong = document.createElement('strong');
    strong.textContent = label;
    text.append(strong);
    if (help) {
      const small = document.createElement('small');
      small.textContent = help;
      text.append(small);
    }
    const check = document.createElement('span');
    check.className = 'aza-diy-choice__check';
    check.setAttribute('aria-hidden', 'true');
    body.append(text, check);
    el.append(input, body);
    return el;
  }

  // De verhoudingsbalk: elk ingrediënt een segment naar gewicht, met een
  // legenda in grammen. Live in de receptkaart en groot in het resultaat.
  function ratioView(plan, locale, copy, compact = false) {
    const wrap = document.createElement('div');
    wrap.className = `aza-diy-ratio${compact ? ' aza-diy-ratio--compact' : ''}`;
    const total = plan.rows.reduce((sum, row) => sum + row.amount, 0) || 1;
    const bar = document.createElement('div');
    bar.className = 'aza-diy-ratio__bar';
    bar.setAttribute('aria-hidden', 'true');
    const legend = document.createElement('ul');
    legend.className = 'aza-diy-ratio__legend';
    plan.rows.forEach((row, index) => {
      const tone = index % 6;
      const seg = document.createElement('span');
      seg.className = `aza-diy-ratio__seg aza-diy-tone--${tone}`;
      seg.style.flexGrow = String(row.amount / total * 100);
      bar.append(seg);
      const li = document.createElement('li');
      const swatch = document.createElement('span');
      swatch.className = `aza-diy-ratio__swatch aza-diy-tone--${tone}`;
      swatch.setAttribute('aria-hidden', 'true');
      const name = document.createElement('span');
      name.className = 'aza-diy-ratio__name';
      name.textContent = nameOf(row.ingredient, locale);
      const amount = document.createElement('span');
      amount.className = 'aza-diy-ratio__amount';
      amount.textContent = row.kind === 'parts'
        ? `${fmt(row.amount, locale)} g · ${row.parts} ${row.parts === 1 ? copy.parts_one : copy.parts_many}`
        : row.scent
          ? `${fmt(row.amount, locale)} g · ${copy.drops(row.drops)}`
          : `${fmt(row.amount, locale)} g · ${fmt(Math.round(row.pct * 10) / 10, locale)}%`;
      li.append(swatch, name, amount);
      legend.append(li);
    });
    wrap.append(bar, legend);
    return wrap;
  }

  const productJsonCache = new Map();
  function getProductJson(handle) {
    if (!productJsonCache.has(handle)) {
      const rootPath = window.Shopify?.routes?.root || '/';
      productJsonCache.set(handle, fetch(`${rootPath}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null));
    }
    return productJsonCache.get(handle);
  }

  function money(cents, locale) {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const tag = { nl: 'nl-NL', de: 'de-DE', fr: 'fr-FR', en: 'en-GB' }[locale] || 'nl-NL';
    try {
      // Het thema schrijft '€8,95' zonder spatie na het teken.
      return new Intl.NumberFormat(tag, { style: 'currency', currency }).format(cents / 100).replace(/^(\D+)\s/, '$1');
    } catch (error) {
      return `€${(cents / 100).toFixed(2).replace('.', ',')}`;
    }
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
  }

  function ingredientRow(key, pct, batch, locale) {
    return { key, ingredient: ING[key], pct, amount: batch * pct / 100, kind: 'formula' };
  }

  function buildPlan(values, locale, copy) {
    const type = TYPES.find((x) => x.id === values.type);
    const pair = carrierPair(values.profile, values.goal);
    const scents = values.scent === 'none' || values.mild ? [] : scentKeys(values.scent, values.avoidCitrus);
    const batch = Number(values.batch) || 50;
    const plan = {
      type,
      rows: [],
      products: [],
      method: [],
      warnings: [],
      summary: '',
      ready: type.ready,
      formulaNote: copy.formula_note
    };

    const addProduct = (key, role = 'formula') => {
      if (!ING[key]?.handle) return;
      if (!plan.products.some((p) => p.key === key)) plan.products.push({ key, ingredient: ING[key], role });
    };
    const addRows = (rows) => rows.forEach(([key, pct]) => {
      const existing = plan.rows.find((row) => row.key === key && row.kind === 'formula');
      if (existing) {
        existing.pct += pct;
        existing.amount = batch * existing.pct / 100;
      } else {
        plan.rows.push(ingredientRow(key, pct, batch, locale));
      }
      addProduct(key, 'formula');
    });
    const leaveOnTypes = ['face-oil','body-oil','hair-oil','hair-mask','conditioner','body-butter','lotion-bar','lip-balm'];
    // Citroen en grapefruit kunnen in zonlicht de huid gevoeliger maken: in
    // producten die op de huid blijven gebruikt het recept frisse niet-citrus.
    let scentSwap = false;
    let doseScents = scents.slice(0, 2);
    if (leaveOnTypes.includes(type.id) && doseScents.some((key) => key === 'eoLemon' || key === 'eoGrapefruit')) {
      doseScents = ['eoPeppermint', 'eoEucalyptus'];
      scentSwap = true;
    }
    const addScentToFormula = () => {
      const total = SCENT_PCT[type.id];
      if (!total || !doseScents.length) return false;
      const factor = (100 - total) / 100;
      plan.rows.forEach((row) => {
        if (row.kind === 'formula') {
          row.pct = Math.round(row.pct * factor * 100) / 100;
          row.amount = batch * row.pct / 100;
        }
      });
      const shares = doseScents.length === 1 ? [1] : [0.6, 0.4];
      doseScents.forEach((key, index) => {
        const pct = Math.round(total * shares[index] * 1000) / 1000;
        const row = ingredientRow(key, pct, batch, locale);
        row.scent = true;
        row.drops = dropsFor(row.amount);
        plan.rows.push(row);
        addProduct(key, 'formula');
      });
      return true;
    };

    switch (type.id) {
      case 'face-oil':
        addRows([[pair[0], 70], [pair[1], 30]]);
        plan.summary = locale === 'nl' ? 'Een watervrije draagoliemix met twee oliën, gekozen op jouw gewenste huidgevoel.' : 'A water-free two-carrier-oil blend selected for your preferred skin feel.';
        plan.method = locale === 'nl'
          ? ['Reinig en droog fles, maatbeker en weegschaaloppervlak.', 'Weeg beide oliën rechtstreeks in een schone fles of beker.', 'Meng rustig, sluit af en noteer samenstelling en datum.', 'Test eerst een kleine hoeveelheid op een beperkt huidgebied.']
          : ['Clean and dry the bottle, vessel and scale surface.', 'Weigh both oils into a clean bottle or vessel.', 'Mix gently, close and label with formula and date.', 'Try a small amount on a limited skin area first.'];
        break;
      case 'body-oil':
        addRows([[pair[0], 60], [pair[1], 40]]);
        plan.summary = locale === 'nl' ? 'Een eenvoudige lichaamsolie zonder water, emulsie of conserveringssysteem.' : 'A simple body oil without water, emulsion or preservation system.';
        plan.method = locale === 'nl'
          ? ['Werk met volledig droge materialen.', 'Weeg beide oliën en meng tot één heldere blend.', 'Bewaar afgesloten en voorkom dat water in de verpakking komt.', 'Gebruik eerst een kleine hoeveelheid om te beoordelen hoe de blend aanvoelt.']
          : ['Work with completely dry tools.', 'Weigh and combine both oils.', 'Store closed and keep water out of the container.', 'Start with a small amount to judge the feel.'];
        break;
      case 'hair-oil':
      case 'hair-mask':
      case 'conditioner': {
        const third = values.profile === 'hair-fine' ? 'broccoli' : values.profile === 'scalp' ? 'castor' : 'jojoba';
        addRows([[pair[0], 50], [pair[1], 30], [third, 20]]);
        plan.summary = locale === 'nl'
          ? (type.id === 'conditioner' ? 'Een watervrije pre-wash verzorgingsmix. Dit is bewust geen waterhoudende conditioner.' : 'Een watervrije haaroliemix voor lengtes, punten of als pre-wash behandeling.')
          : (type.id === 'conditioner' ? 'A water-free pre-wash conditioning blend, deliberately not a water-based conditioner.' : 'A water-free hair-oil blend for lengths, ends or pre-wash use.');
        plan.method = locale === 'nl'
          ? ['Weeg de drie oliën in een droge beker.', 'Meng rustig en giet in een afsluitbare fles.', 'Begin met weinig product en bepaal zelf hoeveel jouw haar prettig vindt.', 'Bij gebruik als pre-wash: uitwassen met je normale wasroutine.']
          : ['Weigh the three oils into a dry vessel.', 'Mix gently and transfer to a closed bottle.', 'Start with a small amount and adjust to your hair feel.', 'For pre-wash use, wash out with your normal routine.'];
        break;
      }
      case 'body-butter':
        addRows([['shea', 60], [pair[0], 40]]);
        plan.summary = locale === 'nl' ? 'Een romige body butter van sheaboter en olie. Er zit geen water in, dus er is geen conserveermiddel nodig.' : 'A creamy body butter of shea butter and oil. It contains no water, so it needs no preservative.';
        plan.method = locale === 'nl'
          ? ['Laat de sheaboter zacht worden au bain-marie zonder onnodig hoog te verhitten.', 'Roer de olie erdoor tot de massa egaal is.', 'Laat gecontroleerd afkoelen en roer tussendoor voor een gelijkmatige textuur.', 'Vul in een schone, droge pot en voorkom watercontact.']
          : ['Soften the shea butter gently in a water bath.', 'Stir in the oil until uniform.', 'Cool in a controlled way and stir during cooling for an even texture.', 'Fill a clean dry jar and keep water out.'];
        break;
      case 'lotion-bar': {
        // Vaste lotion (lotion bar): bijenwas, boter en olie in bijna gelijke
        // delen, zonder water en dus zonder conservering. Smelt op de huid.
        const barOil = values.profile === 'dry' ? 'avocado' : values.profile === 'sensitive' ? 'jojoba' : 'grapeseed';
        addRows([['beeswax', 30], ['shea', 35], [barOil, 35]]);
        plan.summary = locale === 'nl'
          ? 'Een vaste lotion van bijenwas, boter en olie. Er zit geen water in, dus er is geen conserveermiddel nodig. Wrijf hem over je huid: hij smelt door je lichaamswarmte.'
          : 'A solid lotion of beeswax, butter and oil. It contains no water, so it needs no preservative. Rub it over your skin and it melts with your body heat.';
        plan.method = locale === 'nl'
          ? ['Weeg de bijenwas en de sheaboter af en smelt ze samen au bain-marie, op laag vuur.', `Haal de beker van het vuur en roer de ${nameOf(ING[barOil], locale).toLowerCase()} erdoor tot alles helder en egaal is.`, 'Giet in een siliconen vorm of in kleine blikjes en laat een paar uur uitharden op een koele plek. Bewaar droog en koel.']
          : ['Weigh the beeswax and shea butter and melt them together in a water bath over low heat.', `Remove from the heat and stir in the ${nameOf(ING[barOil], locale).toLowerCase()} until clear and even.`, 'Pour into a silicone mould or small tins and leave to set for a few hours somewhere cool. Store dry and cool.'];
        break;
      }
      case 'lip-balm':
        addRows([['cocoa', 45], ['jojoba', 35], ['beeswax', 20]]);
        plan.summary = locale === 'nl' ? 'Een compacte watervrije balsem met boter, vloeibare olie en bijenwas.' : 'A compact water-free balm with butter, liquid oil and beeswax.';
        plan.method = locale === 'nl'
          ? ['Weeg boter en bijenwas en smelt die voorzichtig samen au bain-marie.', 'Haal van de warmte en roer de jojobaolie erdoor.', 'Giet direct in een schone, droge balmverpakking.', 'Laat volledig uitharden voordat je afsluit.']
          : ['Weigh butter and beeswax and melt gently in a water bath.', 'Remove from heat and stir in the jojoba oil.', 'Pour into a clean dry balm container.', 'Allow to set fully before closing.'];
        break;
      case 'face-mask':
      case 'body-mask': {
        const clays = clayPair(values.profile, values.goal);
        addRows([[clays[0], 70], [clays[1], 30]]);
        const waterKey = hydrosol(values.profile);
        addProduct(waterKey, 'optional');
        plan.summary = locale === 'nl' ? 'Een droge kleimix die je droog bewaart en per gebruik vers aanmaakt.' : 'A dry clay blend stored dry and mixed fresh for each use.';
        plan.method = locale === 'nl'
          ? ['Weeg en meng de droge poeders grondig.', 'Bewaar de hoofdvoorraad volledig droog en afgesloten.', 'Neem per gebruik alleen een kleine portie uit de pot.', `Meng die portie vlak voor gebruik met water of ${nameOf(ING[waterKey], locale)} tot een smeerbare pasta. Gooi een aangemaakte rest weg.`]
          : ['Weigh and combine the dry powders thoroughly.', 'Store the main batch completely dry and closed.', 'Take out only a small portion for each use.', `Mix that portion just before use with water or ${nameOf(ING[waterKey], locale)} to a spreadable paste. Discard mixed leftovers.`];
        break;
      }
      case 'hair-wash':
        addRows([['reetha', 60], ['ghassoul', 40]]);
        plan.summary = locale === 'nl' ? 'Een droge kruiden- en kleimix voor vers aanmaken per wasbeurt. Geen houdbare waterige shampoo.' : 'A dry botanical and clay hair-wash mix, prepared fresh for each wash rather than stored with water.';
        plan.method = locale === 'nl'
          ? ['Meng reetha en ghassoul droog en gelijkmatig.', 'Bewaar droog in een afgesloten pot.', 'Maak per wasbeurt een kleine hoeveelheid vers aan met lauw water.', 'Vermijd ogen, spoel ruim uit en bewaar geen aangemaakte rest.']
          : ['Combine reetha and ghassoul evenly while dry.', 'Store dry in a closed jar.', 'Mix a small fresh portion with lukewarm water for each wash.', 'Avoid eyes, rinse thoroughly and do not store the wet mixture.'];
        break;
      case 'dry-shampoo':
        addRows([['whiteClay', 65], ['ghassoul', 35]]);
        plan.summary = locale === 'nl' ? 'Een volledig droge poedermix voor spaarzaam gebruik bij de haarwortel.' : 'A completely dry powder blend for sparing use at the hair roots.';
        plan.method = locale === 'nl'
          ? ['Meng beide poeders langzaam zodat zo min mogelijk stof vrijkomt.', 'Bewaar droog en goed afgesloten.', 'Breng zeer spaarzaam aan bij de haarwortel en werk rustig in.', 'Vermijd inademing en contact met ogen. Borstel overtollig poeder zorgvuldig uit.']
          : ['Mix both powders slowly to minimise airborne dust.', 'Store dry and closed.', 'Apply very sparingly at the roots and work in gently.', 'Avoid inhalation and eye contact. Brush out excess powder carefully.'];
        plan.warnings.push(locale === 'nl' ? 'Poeders kunnen stuiven. Niet richting gezicht aanbrengen en niet inademen.' : 'Powders can become airborne. Keep away from the face and avoid inhalation.');
        break;
      case 'body-scrub':
        addRows([['epsom', 70], [pair[0], 30]]);
        plan.summary = locale === 'nl' ? 'Een eenvoudige watervrije lichaamsscrub met mineraalzout en olie.' : 'A simple water-free body scrub with mineral salt and oil.';
        plan.method = locale === 'nl'
          ? ['Weeg zout en olie in een droge kom.', 'Meng tot alle kristallen licht met olie bedekt zijn.', 'Vul in een droge pot en voorkom water in de hoofdvoorraad.', 'Gebruik voorzichtig op intacte huid en let op een gladde douche- of badvloer.']
          : ['Weigh salt and oil into a dry bowl.', 'Mix until crystals are lightly coated.', 'Fill a dry jar and keep water out of the main batch.', 'Use gently on intact skin and take care with a slippery bath or shower floor.'];
        break;
      case 'bath-mix':
        addRows([['epsom', 70], ['deadSeaFine', 30]]);
        plan.summary = locale === 'nl' ? 'Een droge minerale zoutmix. Geur wordt niet automatisch in het badmengsel gedoseerd.' : 'A dry mineral salt blend. Scent is not automatically dosed into the bath blend.';
        plan.method = locale === 'nl'
          ? ['Weeg beide zouten en meng droog.', 'Bewaar vochtvrij en goed afgesloten.', 'Los een passende hoeveelheid volledig op in bad- of voetenbadwater.', 'Stop bij huidirritatie en houd de droge voorraad vrij van water.']
          : ['Weigh and mix both salts while dry.', 'Store sealed and away from moisture.', 'Dissolve a suitable amount fully in bath or foot-soak water.', 'Stop if irritation occurs and keep the stored mix dry.'];
        break;
      case 'soap-base': {
        const base = soapBase(values.profile, values.goal);
        addRows([[base, 100]]);
        plan.summary = locale === 'nl' ? 'Een route via kant-en-klare smeltzeepbasis. De assistent doet bewust geen loogberekening.' : 'A route using a ready-made melt-and-pour soap base. The assistant deliberately avoids lye calculations.';
        plan.method = locale === 'nl'
          ? ['Weeg de benodigde hoeveelheid zeepbasis.', 'Snijd klein en smelt volgens de instructies van de leverancier van de basis.', 'Wil je kleur of geur toevoegen, blijf binnen de maximale toevoeging van de zeepbasis én de productinformatie van het additief.', 'Giet in een geschikte vorm en laat volledig afkoelen voordat je ontvormt.']
          : ['Weigh the required soap base.', 'Cut and melt according to the base supplier instructions.', 'For colour or scent additions, stay within both the soap-base maximum and the additive product information.', 'Pour into a suitable mould and cool fully before unmoulding.'];
        break;
      }
      case 'diffuser': {
        const blend = scents.length ? scents : ['eoLavender', 'eoCedar'];
        blend.slice(0, 2).forEach((key, index) => {
          const parts = index === 0 ? 2 : 1;
          plan.rows.push({ key, ingredient: ING[key], parts, amount: batch * parts / 3, kind: 'parts' });
          addProduct(key, 'formula');
        });
        plan.formulaNote = copy.diffuser_note;
        plan.summary = locale === 'nl' ? 'Een geurverhouding voor de diffuser. De assistent bepaalt geen universeel aantal druppels.' : 'A diffuser scent ratio. The assistant does not set a universal drop count.';
        plan.method = locale === 'nl'
          ? ['Gebruik de verhouding 2 delen van de eerste olie op 1 deel van de tweede.', 'Bepaal de totale hoeveelheid uitsluitend uit de handleiding van jouw diffuser.', 'Start lager dan het maximum en ventileer de ruimte.', 'Reinig het reservoir volgens de handleiding van het apparaat.']
          : ['Use a 2-part to 1-part ratio.', 'Set the total amount only from your diffuser manual.', 'Start below the maximum and ventilate the room.', 'Clean the reservoir according to the device manual.'];
        break;
      }
      case 'room-spray': {
        const waterKey = values.scent === 'fresh' ? 'peppermintWater' : values.scent === 'floral' ? 'lavenderWater' : values.scent === 'warm' ? 'geraniumWater' : 'neroliWater';
        const blend = scents.length ? scents.slice(0, 2) : [];
        const scentTotal = blend.length ? 2 : 0;
        const alcoholPct = blend.length ? 88 : 90;
        const waterPct = 10;

        addRows([['perfumersAlcohol', alcoholPct], [waterKey, waterPct]]);
        if (blend.length === 1) {
          addRows([[blend[0], scentTotal]]);
        } else if (blend.length >= 2) {
          addRows([[blend[0], 1.3], [blend[1], 0.7]]);
        }

        plan.summary = locale === 'nl'
          ? (blend.length ? 'Een complete kamerspray op alcoholbasis met hydrosol en een lichte etherische-olieblend.' : 'Een eenvoudige kamerspray op alcoholbasis met hydrosol, zonder extra etherische olie.')
          : (blend.length ? 'A complete alcohol-based room spray with hydrosol and a light essential-oil blend.' : 'A simple alcohol-based room spray with hydrosol and no added essential oil.');
        plan.formulaNote = locale === 'nl'
          ? 'Gebruik parfumeursalcohol of ethanol van 95-96% die geschikt is voor parfum/roomspray. Gebruik geen spiritus of gedenatureerde huishoudalcohol met onbekende toevoegingen.'
          : 'Use perfumers alcohol or 95-96% ethanol suitable for fragrance/room-spray use. Do not use household methylated spirits with unknown additives.';
        plan.method = locale === 'nl'
          ? [
              'Weeg de parfumeursalcohol in een schone, volledig droge beker.',
              ...(blend.length ? ['Voeg de etherische oliën toe aan de alcohol en roer tot de geurblend volledig is verdeeld.'] : []),
              `Voeg ${nameOf(ING[waterKey], locale)} langzaam toe terwijl je rustig roert.`,
              'Giet in een alcoholbestendige fijnverstuiver, sluit af en etiketteer met samenstelling en datum.',
              'Laat 12-24 uur staan en controleer of de spray homogeen blijft voordat je hem normaal gebruikt.'
            ]
          : [
              'Weigh the perfumers alcohol into a clean, completely dry vessel.',
              ...(blend.length ? ['Add the essential oils to the alcohol and stir until the scent blend is fully dispersed.'] : []),
              `Slowly add ${nameOf(ING[waterKey], locale)} while stirring gently.`,
              'Transfer to an alcohol-compatible fine-mist bottle and label with formula and date.',
              'Leave for 12-24 hours and check that the spray remains homogeneous before normal use.'
            ];
        plan.warnings.push(locale === 'nl'
          ? 'Ontvlambaar door het hoge alcoholpercentage. Uit de buurt houden van hitte, vonken, kaarsen en open vuur. Alleen in een geventileerde ruimte mengen en gebruiken.'
          : 'Flammable because of the high alcohol content. Keep away from heat, sparks, candles and open flame. Mix and use only with good ventilation.');
        plan.warnings.push(locale === 'nl'
          ? 'Niet op huid, gezicht, voedsel of huisdieren sprayen. Test eerst op een onopvallend stukje als nevel op oppervlakken kan terechtkomen.'
          : 'Do not spray on skin, face, food or pets. Test an inconspicuous area first if mist can land on surfaces.');
        break;
      }
      case 'cream':
      case 'shower-gel':
      case 'face-scrub': {
        plan.ready = false;
        plan.summary = copy.no_formula;
        const waterKey = hydrosol(values.profile);
        addProduct(waterKey, 'optional');
        if (type.id === 'cream') {
          addProduct(pair[0], 'optional');
          plan.method = locale === 'nl'
            ? ['Kies eerst een complete, gevalideerde emulsiebasis of formule.', 'Leg oliepercentage, emulgator, conserveermiddel en pH samen vast.', 'Voeg pas daarna Aza-ingrediënten toe binnen de grenzen van die formule.', 'Maak geen waterhoudend product voor opslag zonder passende conserverings- en stabiliteitscontrole.']
            : ['Start with a complete validated emulsion base or formula.', 'Define oil phase, emulsifier, preservative and pH together.', 'Only then add Aza ingredients within that formula limits.', 'Do not store a water-based product without appropriate preservation and stability control.'];
        } else if (type.id === 'room-spray') {
          plan.method = locale === 'nl'
            ? ['Kies eerst een geschikte spraybasis met oplosmiddel of solubilisator en zo nodig conservering.', 'Controleer materiaalcompatibiliteit en maximale geurbelasting van die basis.', 'Bepaal daarna pas welke geurolie of etherische olie binnen de basislimiet past.', 'Etiketteer de spray en gebruik hem niet als huidproduct.']
            : ['Start with a suitable spray base with solvent or solubiliser and preservation where needed.', 'Check packaging compatibility and the base scent limit.', 'Only then select a scent within that limit.', 'Label the spray and do not use it as a skin product.'];
        } else if (type.id === 'shower-gel') {
          plan.summary = locale === 'nl' ? 'Een echte douchegel vraagt een complete surfactantbasis, conservering en pH-controle. De assistent voegt daar niet zomaar losse ingrediënten aan toe.' : 'A true shower gel needs a complete surfactant base, preservation and pH control. The assistant does not improvise that from loose ingredients.';
          plan.method = locale === 'nl'
            ? ['Start met een gevalideerde douchegel- of surfactantbasis.', 'Controleer het toegestane bereik voor verdikking, geur, pH en conservering.', 'Voeg alleen ingrediënten toe die volgens de basisdocumentatie compatibel zijn.', 'Controleer de pH en stabiliteit van het eindproduct voordat je het bewaart of weggeeft.']
            : ['Start with a validated shower-gel or surfactant base.', 'Check the permitted range for thickening, scent, pH and preservation.', 'Only add ingredients compatible with the base documentation.', 'Check pH and final-product stability before storing or sharing it.'];
        } else {
          plan.summary = locale === 'nl' ? 'Voor een gezichtsscrub kiest de assistent bewust geen willekeurig schuurdeeltje. De deeltjesgrootte, vorm en basis moeten mild genoeg zijn voor gezichtshuid.' : 'For a face scrub the assistant deliberately avoids choosing an arbitrary abrasive. Particle size, shape and the base need to be gentle enough for facial skin.';
          plan.method = locale === 'nl'
            ? ['Kies een complete gezichtsscrubbasis of een recept waarvan het scrubmateriaal en de deeltjesgrootte bekend zijn.', 'Gebruik geen grof zout, suiker of onbekend poeder als automatische vervanging.', 'Controleer de productinformatie van eventuele oliën of hydrosolen die de basis toestaat.', 'Test een kleine hoeveelheid en stop bij irritatie.']
            : ['Choose a complete facial-scrub base or a formula with a known exfoliant and particle size.', 'Do not automatically substitute coarse salt, sugar or unknown powders.', 'Check the product information for any oils or hydrosols permitted by the base.', 'Try a small amount and stop if irritation occurs.'];
        }
        break;
      }
    }

    const canSuggestScent = !values.mild && values.scent !== 'none';

    if (canSuggestScent && plan.ready && !['diffuser', 'room-spray'].includes(type.id) && addScentToFormula()) {
      const names = doseScents.map((key) => nameOf(ING[key], locale).replace(/ etherische olie$| essential oil$/i, '').toLowerCase());
      const when = {
        'lip-balm': locale === 'nl' ? 'Roer de etherische oliën erdoor zodra het mengsel van het vuur is en net begint af te koelen, en giet direct.' : 'Stir in the essential oils once the mixture is off the heat and just starting to cool, then pour straight away.',
        'body-butter': locale === 'nl' ? 'Voeg de etherische oliën toe als het mengsel onder de 40 °C is en roer goed door.' : 'Add the essential oils once the mixture is below 40 °C and stir well.',
        'lotion-bar': locale === 'nl' ? 'Laat het mengsel een paar minuten afkoelen en roer de etherische oliën erdoor vlak voordat je giet.' : 'Let the mixture cool for a few minutes and stir in the essential oils just before pouring.',
        'soap-base': locale === 'nl' ? 'Roer de etherische oliën door de gesmolten zeepbasis vlak voordat je giet, als die iets is afgekoeld.' : 'Stir the essential oils into the melted soap base just before pouring, once it has cooled slightly.'
      }[type.id] || (['face-mask', 'body-mask', 'hair-wash', 'dry-shampoo', 'bath-mix', 'body-scrub'].includes(type.id)
        ? (locale === 'nl' ? 'Druppel de etherische oliën over de mix, sluit de pot en schud of roer tot alles gelijkmatig verdeeld is.' : 'Drip the essential oils over the mix, close the jar and shake or stir until evenly distributed.')
        : (locale === 'nl' ? 'Voeg de etherische oliën als laatste toe en meng rustig door.' : 'Add the essential oils last and mix gently.'));
      plan.method.splice(Math.max(1, plan.method.length - 1), 0, when);
      plan.summary += locale === 'nl'
        ? ` Met een lichte geur van ${names.join(' en ')} (${fmt(SCENT_PCT[type.id], locale)}% etherische olie).`
        : ` With a light scent of ${names.join(' and ')} (${fmt(SCENT_PCT[type.id], locale)}% essential oil).`;
      if (scentSwap) {
        plan.warnings.push(locale === 'nl'
          ? 'Voor een product dat op de huid blijft gebruikt het recept pepermunt en eucalyptus in plaats van citroen en grapefruit. Die citrusoliën kunnen in zonlicht de huid gevoeliger maken.'
          : 'For a product that stays on the skin the recipe uses peppermint and eucalyptus instead of lemon and grapefruit, which can make skin more sensitive to sunlight.');
      }
      if (type.id === 'bath-mix') {
        plan.warnings.push(locale === 'nl'
          ? 'Etherische olie lost niet op in water. Los de badzout volledig op en beweeg het water goed voordat je erin gaat.'
          : 'Essential oils do not dissolve in water. Dissolve the bath salts fully and swirl the water well before getting in.');
      }
      plan.warnings.push(locale === 'nl'
        ? 'Met etherische olie: niet voor kinderen jonger dan 6 jaar en vraag bij zwangerschap eerst advies. Weeg kleine hoeveelheden precies af; het aantal druppels is een richtgetal.'
        : 'With essential oils: not for children under 6, and ask for advice first if pregnant. Weigh small amounts precisely; the drop count is a guide.');
    }

    if (values.mild) {
      plan.warnings.push(locale === 'nl'
        ? 'Extra mild staat aan. Etherische oliën zijn daarom uit het recept en de geursuggesties gefilterd.'
        : 'Extra mild is enabled, so essential oils were filtered from the recipe and scent suggestions.');
    }

    if (!['diffuser','room-spray'].includes(type.id) && plan.products.some((p) => p.ingredient.eo)) {
      plan.warnings.push(locale === 'nl'
        ? 'Etherische olie blijft geconcentreerd. Niet onverdund op de huid gebruiken en altijd de productwaarschuwingen lezen.'
        : 'Essential oils remain concentrated. Do not use undiluted on skin and always read the product warnings.');
    }

    if (type.id === 'face-mask' || type.id === 'hair-wash') {
      plan.warnings.push(locale === 'nl'
        ? 'Zodra je water of hydrosol aan een droge mix toevoegt, maak je alleen een verse portie voor direct gebruik. Bewaar geen nat restant.'
        : 'Once water or hydrosol is added to a dry mix, prepare only a fresh portion for immediate use and do not store wet leftovers.');
    }

    if (!plan.ready) {
      plan.warnings.push(locale === 'nl'
        ? 'Dit is een bewuste stop in de assistent, niet een ontbrekend recept. Waterhoudende producten vragen samenhangende controle van conservering, pH, oplosbaarheid en stabiliteit.'
        : 'This is a deliberate stop, not a missing recipe. Water-based products need combined control of preservation, pH, solubility and stability.');
    }

    return plan;
  }

  function init(root) {
    if (root.dataset.diyReady === '1') return;
    root.dataset.diyReady = '1';

    const locale = ['nl','en','de','fr'].includes(root.dataset.locale) ? root.dataset.locale : 'en';
    const copy = COPY[locale] || COPY.en;
    const form = root.querySelector('[data-diy-form]');
    const result = root.querySelector('[data-diy-result]');
    const useBox = root.querySelector('[data-diy-use-options]');
    const typeBox = root.querySelector('[data-diy-type-options]');
    const goalBox = root.querySelector('[data-diy-goal-options]');
    const profileBox = root.querySelector('[data-diy-profile-options]');
    const scentBox = root.querySelector('[data-diy-scent-options]');
    const next = root.querySelector('[data-diy-next]');
    const back = root.querySelector('[data-diy-back]');
    const reset = root.querySelector('[data-diy-reset]');
    const error = root.querySelector('[data-diy-error]');
    const progress = root.querySelector('[data-diy-progress]');
    const progressLabel = root.querySelector('[data-diy-progress-label]');
    const stepper = root.querySelector('[data-diy-stepper]');
    const card = root.querySelector('[data-diy-card]');
    const cardTitle = root.querySelector('[data-diy-card-title]');
    const cardList = root.querySelector('[data-diy-card-list]');
    const cardRatio = root.querySelector('[data-diy-card-ratio]');
    const cardRatioBody = root.querySelector('[data-diy-card-ratio-body]');
    const editButton = root.querySelector('[data-diy-edit]');
    const workspace = root.querySelector('.aza-diy-lab__workspace');
    const body = root.querySelector('[data-diy-body]');
    let media = {};
    try { media = JSON.parse(root.querySelector('[data-diy-media]')?.textContent || '{}'); } catch (mediaError) { media = {}; }
    const addCart = root.querySelector('[data-diy-add-cart]');
    const viewCart = root.querySelector('[data-diy-view-cart]');
    const cartNote = root.querySelector('[data-diy-cart-note]');
    let step = 1;
    let maxStep = 1;
    let currentPlan = null;
    const excluded = new Set();

    root.querySelectorAll('[data-diy-copy]').forEach((el) => {
      const key = el.dataset.diyCopy;
      if (typeof copy[key] === 'string') el.textContent = copy[key];
    });

    USES.forEach((item) => useBox.append(makeChoice('use', item.id, labelOf(item, locale), helpOf(item, locale), false, 'photo', media[item.id])));
    SCENTS.forEach((item, index) => scentBox.append(makeChoice('scent', item.id, labelOf(item, locale), helpOf(item, locale), index === 0, 'card')));

    // Stappenbalk met namen. Afgeronde stappen zijn knoppen om terug te gaan.
    copy.step_short.forEach((name, index) => {
      const li = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.diyGoto = String(index + 1);
      const num = document.createElement('span');
      num.className = 'aza-diy-lab__step-num';
      num.textContent = String(index + 1);
      const label = document.createElement('span');
      label.className = 'aza-diy-lab__step-name';
      label.textContent = name;
      button.append(num, label);
      li.append(button);
      stepper.append(li);
    });

    function selected(name) {
      return form.querySelector(`[name="${name}"]:checked`)?.value || '';
    }

    function selectedType() {
      return TYPES.find((x) => x.id === selected('type')) || null;
    }

    function renderTypesForUse() {
      const use = USES.find((x) => x.id === selected('use'));
      const previousType = selected('type');
      typeBox.replaceChildren();
      if (!use) return;
      const matchingTypes = TYPES.filter((item) => item.ready && use.groups.includes(item.group));
      matchingTypes.forEach((item) => {
        typeBox.append(makeChoice('type', item.id, labelOf(item, locale), helpOf(item, locale), item.id === previousType, 'card'));
      });
      if (previousType && !matchingTypes.some((item) => item.id === previousType)) {
        goalBox.replaceChildren();
        profileBox.replaceChildren();
      }
    }

    function renderAdaptiveOptions() {
      const type = selectedType();
      if (!type) {
        goalBox.replaceChildren();
        profileBox.replaceChildren();
        return;
      }
      const currentGoal = selected('goal');
      const currentProfile = selected('profile');
      goalBox.replaceChildren();
      profileBox.replaceChildren();

      const goals = GOALS.filter((x) => x.groups.includes(type.group));
      const profiles = PROFILES.filter((x) => x.groups.includes(type.group) || (type.id === 'soap-base' && ['sensitive', 'dry'].includes(x.id)));
      goals.forEach((item, index) => goalBox.append(makeChoice('goal', item.id, labelOf(item, locale), '', item.id === currentGoal || (!currentGoal && index === 0), 'chip')));
      profiles.forEach((item, index) => profileBox.append(makeChoice('profile', item.id, labelOf(item, locale), '', item.id === currentProfile || (!currentProfile && index === 0), 'chip')));
    }

    function renderBatchOptions() {
      const diffuser = selected('type') === 'diffuser';
      const amounts = diffuser ? [3, 6, 12, 30] : [30, 50, 100, 250];
      const previous = selected('batch');
      form.querySelectorAll('[name="batch"]').forEach((input, index) => {
        input.value = String(amounts[index]);
        input.nextElementSibling.textContent = `${amounts[index]} g`;
        input.checked = previous === String(amounts[index]);
      });
      if (!selected('batch')) form.querySelectorAll('[name="batch"]')[1].checked = true;
    }

    // Een andere keuze kan een latere stap leegmaken (ander gebruik wist het
    // product). De stappenbalk mag dan niet meer verder springen dan de eerste
    // stap die weer ingevuld moet worden, anders loopt 'Bekijk mijn recept' vast.
    function capMaxStep() {
      if (!selected('use')) maxStep = 1;
      else if (!selectedType()) maxStep = Math.min(maxStep, 2);
      else if (!selected('goal') || !selected('profile')) maxStep = Math.min(maxStep, 3);
      updateStepper();
    }

    useBox.addEventListener('change', () => {
      renderTypesForUse();
      renderAdaptiveOptions();
      capMaxStep();
    });
    typeBox.addEventListener('change', () => {
      renderAdaptiveOptions();
      renderBatchOptions();
      capMaxStep();
    });

    function values() {
      const fd = new FormData(form);
      return {
        use: String(fd.get('use') || ''),
        type: String(fd.get('type') || ''),
        goal: String(fd.get('goal') || ''),
        profile: String(fd.get('profile') || ''),
        scent: String(fd.get('scent') || 'none'),
        mild: fd.get('mild') === '1',
        avoidCitrus: fd.get('avoidCitrus') === '1',
        batch: String(fd.get('batch') || '50')
      };
    }

    function humanValue(name, value) {
      if (name === 'use') return labelOf(USES.find((x) => x.id === value), locale);
      if (name === 'type') return labelOf(TYPES.find((x) => x.id === value), locale);
      if (name === 'goal') return labelOf(GOALS.find((x) => x.id === value), locale);
      if (name === 'profile') return labelOf(PROFILES.find((x) => x.id === value), locale);
      if (name === 'scent') return labelOf(SCENTS.find((x) => x.id === value), locale);
      return value;
    }

    // De receptkaart naast de vragen: laat zien wat er gekozen is en rekent
    // vanaf stap 3 de verhouding live uit met dezelfde rekenregels als het
    // resultaat (buildPlan), dus wat je ziet is wat je krijgt.
    function updateCard() {
      if (!card) return;
      const v = values();
      const rows = [];
      if (v.use) rows.push([copy.step_short[0], humanValue('use', v.use)]);
      if (v.type) rows.push([copy.step_short[1], humanValue('type', v.type)]);
      if (maxStep >= 3 && v.goal) rows.push([copy.goal_label, humanValue('goal', v.goal)]);
      if (maxStep >= 3 && v.profile) rows.push([copy.profile_label, humanValue('profile', v.profile)]);
      if (maxStep >= 4) rows.push([copy.step_short[3], v.mild ? copy.mild_title : humanValue('scent', v.scent)]);
      if (maxStep >= 5) rows.push([copy.step_short[4], `${v.batch} g`]);
      card.hidden = rows.length === 0 || !result.hidden;
      body?.classList.toggle('has-card', !card.hidden);
      cardTitle.textContent = v.type ? copy.plan_for(humanValue('type', v.type)) : copy.card_title_empty;
      cardList.replaceChildren(...rows.map(([key, value]) => {
        const row = document.createElement('div');
        const dt = document.createElement('dt');
        const dd = document.createElement('dd');
        dt.textContent = key;
        dd.textContent = value;
        row.append(dt, dd);
        return row;
      }));
      const type = selectedType();
      if (type && type.ready && v.goal && v.profile && maxStep >= 3) {
        const plan = buildPlan(v, locale, copy);
        cardRatioBody.replaceChildren(ratioView(plan, locale, copy, true));
        cardRatio.hidden = plan.rows.length === 0;
      } else {
        cardRatio.hidden = true;
      }
    }

    function updateStepper(inResult = false) {
      stepper.querySelectorAll('[data-diy-goto]').forEach((button) => {
        const n = Number(button.dataset.diyGoto);
        const current = !inResult && n === step;
        button.disabled = !inResult && n > maxStep;
        button.classList.toggle('is-current', current);
        button.classList.toggle('is-complete', inResult || (n < step) || (n <= maxStep && n !== step));
        if (current) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
    }

    function scrollToWorkspace() {
      const top = workspace.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        workspace.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    }

    function showStep(n) {
      step = Math.max(1, Math.min(5, n));
      root.classList.remove('is-result');
      root.querySelectorAll('[data-diy-step]').forEach((panel) => {
        const active = Number(panel.dataset.diyStep) === step;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      root.querySelectorAll('[data-rail-step]').forEach((item) => {
        const nStep = Number(item.dataset.railStep);
        item.classList.toggle('is-active', nStep === step);
        item.classList.toggle('is-complete', nStep < step);
      });
      maxStep = Math.max(maxStep, step);
      progress.style.width = `${step * 20}%`;
      progressLabel.textContent = `${copy.step_of(step)} · ${copy.step_short[step - 1]}`;
      back.hidden = step === 1;
      next.textContent = step === 5 ? next.dataset.resultLabel : next.dataset.nextLabel;
      error.hidden = true;
      updateStepper();
      updateCard();
    }

    function validateStep() {
      const required = step === 1 ? 'use' : step === 2 ? 'type' : step === 3 ? 'goal' : step === 4 ? 'scent' : 'batch';
      if (!selected(required)) {
        error.textContent = copy.missing;
        error.hidden = false;
        return false;
      }
      if (step === 3 && !selected('profile')) {
        error.textContent = copy.missing;
        error.hidden = false;
        return false;
      }
      return true;
    }

    function renderPlan(plan) {
      const title = root.querySelector('[data-diy-result-title]');
      const summary = root.querySelector('[data-diy-result-summary]');
      const status = root.querySelector('[data-diy-result-status]');
      const formula = root.querySelector('[data-diy-formula]');
      const method = root.querySelector('[data-diy-method]');
      const products = root.querySelector('[data-diy-products]');
      const formulaCard = formula.closest('article');
      const productsSection = products.closest('.aza-diy-lab__products');
      const warnings = root.querySelector('[data-diy-warnings]');
      const warningList = root.querySelector('[data-diy-warning-list]');

      title.textContent = copy.plan_for(labelOf(plan.type, locale));
      summary.textContent = plan.summary;
      status.textContent = plan.ready ? copy.ready : copy.limited;
      status.classList.toggle('is-limited', !plan.ready);
      formulaCard.hidden = !plan.ready;
      productsSection.hidden = !plan.ready;
      addCart.hidden = !plan.ready;

      formula.replaceChildren();
      root.querySelector('[data-diy-result-batch]').textContent = copy.for_batch(values().batch);
      const meta = TYPE_META[plan.type.id];
      const prepEl = root.querySelector('[data-diy-result-prep]');
      const levelEl = root.querySelector('[data-diy-result-level]');
      if (prepEl) { prepEl.hidden = !meta; prepEl.textContent = meta ? copy.prep(meta[0]) : ''; }
      if (levelEl) { levelEl.hidden = !meta; levelEl.textContent = meta ? copy[`level_${meta[1]}`] : ''; }
      if (plan.ready && plan.rows.length) {
        formula.append(ratioView(plan, locale, copy));
      }
      if (plan.ready) {
        const note = document.createElement('div');
        note.className = 'aza-diy-formula__note';
        note.textContent = plan.formulaNote;
        formula.append(note);
      }

      method.replaceChildren();
      plan.method.forEach((text) => {
        const li = document.createElement('li');
        li.textContent = text;
        method.append(li);
      });

      products.replaceChildren();
      const optionalBox = root.querySelector('[data-diy-optional]');
      const optionalList = root.querySelector('[data-diy-optional-list]');
      const externalNote = root.querySelector('[data-diy-external]');
      const totalBox = root.querySelector('[data-diy-total]');
      const totalAmount = root.querySelector('[data-diy-total-amount]');
      optionalList.replaceChildren();
      const formulaHandles = [];
      const rootPath = window.Shopify?.routes?.root || '/';
      const renderToken = Symbol('render');
      renderPlan.token = renderToken;

      const rowsFor = plan.ready ? plan.products : [];
      // Benodigde grammen per product, voor de verpakkingskeuze. Blijft aan het
      // product hangen, ook als het door een vervanger wordt overgenomen.
      rowsFor.forEach((item) => {
        item.need = plan.rows.filter((row) => row.key === item.key).reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
      });
      excluded.clear();
      const prices = new Map();
      const updateTotal = () => {
        let sum = 0;
        let count = 0;
        prices.forEach((cents, key) => {
          if (!excluded.has(key)) { sum += cents; count += 1; }
        });
        totalBox.hidden = prices.size === 0;
        totalAmount.textContent = money(sum, locale);
        addCart.disabled = count === 0;
        addCart.textContent = count ? `${addCart.dataset.label} · ${money(sum, locale)}` : addCart.dataset.label;
      };

      const lines = rowsFor.map((item) => {
        const line = document.createElement('div');
        line.className = 'aza-diy-product';
        if (item.role === 'formula') {
          const pick = document.createElement('label');
          pick.className = 'aza-diy-product__pick';
          const box = document.createElement('input');
          box.type = 'checkbox';
          box.checked = true;
          box.setAttribute('aria-label', nameOf(item.ingredient, locale));
          box.addEventListener('change', () => {
            if (box.checked) excluded.delete(item.key); else excluded.add(item.key);
            line.classList.toggle('is-skipped', !box.checked);
            updateTotal();
          });
          pick.append(box);
          line.append(pick);
        }
        const thumb = document.createElement('span');
        thumb.className = 'aza-diy-product__thumb';
        const info = document.createElement('span');
        info.className = 'aza-diy-product__info';
        const link = document.createElement('a');
        link.href = `${rootPath}products/${item.ingredient.handle}`;
        link.textContent = nameOf(item.ingredient, locale);
        const meta = document.createElement('small');
        meta.textContent = item.role === 'formula' ? copy.used_in_formula : copy.optional_product;
        info.append(link, meta);
        const price = document.createElement('span');
        price.className = 'aza-diy-product__price';
        line.append(thumb, info, price);
        (item.role === 'formula' ? products : optionalList).append(line);
        if (item.role === 'formula' && item.ingredient.handle) formulaHandles.push(item.ingredient.handle);
        return { item, line, thumb, meta, price, link };
      });
      optionalBox.hidden = !rowsFor.some((item) => item.role !== 'formula');
      const hint = root.querySelector('[data-diy-have-hint]');
      if (hint) { hint.textContent = copy.have_it; hint.hidden = !rowsFor.some((item) => item.role === 'formula'); }

      const external = plan.ready ? plan.rows.filter((row) => row.ingredient?.external).map((row) => nameOf(row.ingredient, locale)) : [];
      externalNote.hidden = external.length === 0;
      externalNote.textContent = external.length ? `${copy.external} ${external.join(', ')}` : '';

      totalBox.hidden = true;
      addCart.textContent = addCart.dataset.label;

      // Foto, verpakking en prijs ophalen. De verpakking is dezelfde als die
      // de winkelmandknop kiest (preferredVariant), dus het totaal klopt. Is
      // een ingrediënt uitverkocht en bestaat er een echte gelijke (zelfde
      // plant), dan neemt het recept die automatisch.
      lines.forEach(async (entry) => {
        let key = entry.item.key;
        let variants = await getPurchasableVariants(entry.item.ingredient.handle);
        let variant = preferredVariant(variants || [], entry.item.need);
        let replaced = null;
        if (!variant && ALTERNATIVES[key] && ING[ALTERNATIVES[key]]?.handle) {
          const altKey = ALTERNATIVES[key];
          const altVariant = preferredVariant(await getPurchasableVariants(ING[altKey].handle) || [], entry.item.need);
          if (altVariant) {
            replaced = nameOf(entry.item.ingredient, locale);
            // Was het vinkje al uit voordat de vervanger bekend was, dan blijft het uit.
            if (renderPlan.token === renderToken && excluded.has(key)) { excluded.delete(key); excluded.add(altKey); }
            entry.item.key = altKey;
            entry.item.ingredient = ING[altKey];
            key = altKey;
            variant = altVariant;
            entry.link.href = `${rootPath}products/${ING[altKey].handle}`;
            entry.link.textContent = nameOf(ING[altKey], locale);
          }
        }
        const product = await getProductJson(entry.item.ingredient.handle);
        if (renderPlan.token !== renderToken) return;
        if (product?.featured_image) {
          const img = document.createElement('img');
          img.src = sizedImage(product.featured_image, 160);
          img.alt = '';
          img.width = 56;
          img.height = 56;
          img.loading = 'lazy';
          entry.thumb.replaceChildren(img);
        }
        if (!variant) {
          entry.line.classList.add('is-unavailable');
          entry.meta.textContent = copy.unavailable;
          const box = entry.line.querySelector('input[type="checkbox"]');
          if (box) { box.checked = false; box.disabled = true; }
          excluded.add(key);
          return;
        }
        // Verpakking zonder het kortingslabel uit de variantnaam ('(12.00% korting)').
        const size = String(variant.title || '').toLowerCase() === 'default title' ? '' : String(variant.title).split('(')[0].trim();
        const role = entry.item.role === 'formula' ? copy.used_in_formula : copy.optional_product;
        const parts = [size, replaced ? copy.replaces(replaced) : role].filter(Boolean);
        entry.meta.textContent = parts.join(' · ');
        entry.price.textContent = money(Number(variant.price) || 0, locale);
        if (entry.item.role === 'formula') {
          prices.set(key, Number(variant.price) || 0);
          updateTotal();
        }
      });

      const uniqueFormulaHandles = [...new Set(formulaHandles)];
      addCart.disabled = uniqueFormulaHandles.length === 0;

      warningList.replaceChildren();
      plan.warnings.forEach((text) => {
        const li = document.createElement('li');
        li.textContent = text;
        warningList.append(li);
      });
      warnings.hidden = plan.warnings.length === 0;

      viewCart.hidden = true;
      cartNote.textContent = '';
    }

    next.addEventListener('click', () => {
      if (!validateStep()) return;
      if (step < 5) {
        showStep(step + 1);
        return;
      }
      if (!selectedType()) {
        capMaxStep();
        showStep(selected('use') ? 2 : 1);
        error.textContent = copy.missing;
        error.hidden = false;
        return;
      }
      currentPlan = buildPlan(values(), locale, copy);
      renderPlan(currentPlan);
      form.hidden = true;
      result.hidden = false;
      maxStep = 5;
      root.classList.add('is-result');
      updateStepper(true);
      progress.style.width = '100%';
      progressLabel.textContent = copy.result_eyebrow;
      updateCard();
      result.focus({ preventScroll: true });
      result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });

    back.addEventListener('click', () => { showStep(step - 1); scrollToWorkspace(); });

    stepper.addEventListener('click', (event) => {
      const button = event.target.closest('[data-diy-goto]');
      if (!button || button.disabled) return;
      result.hidden = true;
      form.hidden = false;
      showStep(Number(button.dataset.diyGoto));
      scrollToWorkspace();
    });

    editButton?.addEventListener('click', () => {
      result.hidden = true;
      form.hidden = false;
      showStep(5);
      scrollToWorkspace();
    });

    form.addEventListener('change', updateCard);

    // Stap 1 en 2 hebben één keuze: met muis of vinger ga je meteen door.
    // Met het toetsenbord (pijltjes in de radiogroep, event.detail 0) niet,
    // anders spring je bij elke pijl naar de volgende stap.
    [useBox, typeBox].forEach((box, index) => {
      box.addEventListener('click', (event) => {
        if (event.detail === 0 || !event.target.closest('.aza-diy-choice')) return;
        window.setTimeout(() => {
          if (step === index + 1 && validateStep()) {
            showStep(step + 1);
            scrollToWorkspace();
          }
        }, 220);
      });
    });
    form.addEventListener('submit', (event) => event.preventDefault());

    reset.addEventListener('click', () => {
      result.hidden = true;
      form.hidden = false;
      currentPlan = null;
      form.reset();
      typeBox.replaceChildren();
      goalBox.replaceChildren();
      profileBox.replaceChildren();
      scentBox.querySelector('input')?.click();
      renderBatchOptions();
      maxStep = 1;
      showStep(1);
      workspace.scrollIntoView({ behavior: 'auto', block: 'start' });
    });

    addCart.addEventListener('click', async () => {
      if (!currentPlan || !currentPlan.products.length) return;

      const wanted = new Map();
      currentPlan.products
        .filter((item) => item.role === 'formula' && !excluded.has(item.key) && item.ingredient.handle)
        .forEach((item) => wanted.set(item.ingredient.handle, (wanted.get(item.ingredient.handle) || 0) + (item.need || 0)));
      const handles = [...wanted.keys()];

      if (!handles.length) {
        cartNote.textContent = copy.cart_none;
        return;
      }

      const rootPath = window.Shopify?.routes?.root || '/';
      addCart.disabled = true;
      addCart.setAttribute('aria-busy', 'true');
      cartNote.textContent = copy.cart_busy;

      try {
        const resolved = await Promise.all(handles.map(async (handle) => {
          const variants = await getPurchasableVariants(handle);
          const variant = preferredVariant(variants, wanted.get(handle));
          return variant ? { id: Number(variant.id), quantity: 1 } : null;
        }));
        const items = resolved.filter(Boolean);

        if (!items.length) {
          cartNote.textContent = copy.cart_none;
          return;
        }

        let added = 0;
        const bulkResponse = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });

        if (bulkResponse.ok) {
          added = items.length;
        } else {
          for (const item of items) {
            try {
              const addResponse = await fetch(`${rootPath}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(item)
              });
              if (addResponse.ok) added += 1;
            } catch (itemError) {
              // Eén fout ingrediënt mag de rest van het recept niet blokkeren.
            }
          }
        }

        if (!added) {
          cartNote.textContent = copy.cart_none;
          return;
        }

        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        } else {
          const cart = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
          document.querySelectorAll('[data-header-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
          document.getElementById('site-cart-sidebar')?.show?.();
        }

        // Meetevent voor de evaluatie van de upgrade; een customer-pixel kan hierop abonneren.
        try { window.Shopify?.analytics?.publish?.('aza_diy_add_all', { items_added: added, items_total: handles.length }); } catch (trackError) {}
        cartNote.textContent = added === handles.length ? copy.cart_success(added) : copy.cart_partial(added, handles.length);
        viewCart.hidden = false;
        addCart.textContent = copy.added;
      } catch (err) {
        cartNote.textContent = copy.cart_error;
      } finally {
        addCart.disabled = false;
        addCart.removeAttribute('aria-busy');
      }
    });

    const params = new URLSearchParams(window.location.search);
    const presetType = TYPES.find((item) => item.ready && item.id === params.get('diy_type'));
    if (window.location.hash === '#aza-diy-inspiration' && presetType) {
      const presetUse = USES.find((item) => item.groups.includes(presetType.group));
      const choose = (name, value) => {
        const input = [...form.querySelectorAll(`[name="${name}"]`)].find((item) => item.value === value);
        if (input) input.checked = true;
      };
      if (presetUse) choose('use', presetUse.id);
      renderTypesForUse();
      choose('type', presetType.id);
      renderAdaptiveOptions();
      choose('goal', params.get('diy_goal'));
      choose('profile', params.get('diy_profile'));
      choose('scent', params.get('diy_scent'));
      if (params.get('diy_avoid_citrus') === '1') form.querySelector('[name="avoidCitrus"]').checked = true;
      renderBatchOptions();
      const complete = Boolean(params.get('diy_goal') && params.get('diy_profile'));
      maxStep = complete ? 5 : 3;
      showStep(complete ? 5 : 3);
    } else {
      showStep(1);
    }

    // Een link naar #aza-diy-inspiration (sticky DIY-knop, receptlinks) landt
    // op het Lab; het Lab staat altijd open, er hoeft niets uit te klappen.
    root.classList.add('is-open');
  }

  // Ronde 50: het Lab bouwt zijn keuzes pas op als het in de buurt van het
  // scherm komt (1200 px marge), of meteen bij een link naar
  // #aza-diy-inspiration. Op de homepage staat het ver onder de vouw, en het
  // opbouwen was een lange taak van ~160 ms tijdens het laden (mobiel).
  function start(root) {
    if (window.location.hash === '#aza-diy-inspiration' || !('IntersectionObserver' in window)) {
      init(root);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      init(root);
    }, { rootMargin: '1200px 0px' });
    observer.observe(root);
    window.addEventListener('hashchange', () => {
      if (window.location.hash !== '#aza-diy-inspiration') return;
      observer.disconnect();
      init(root);
    });
  }

  window.azaDiyMotor = {
    COPY, USES, TYPES, TYPE_META, GOALS, PROFILES, SCENTS, ING, SCENT_PCT, ALTERNATIVES,
    nameOf, labelOf, helpOf, fmt, buildPlan, variantGrams, preferredVariant
  };
  document.dispatchEvent(new CustomEvent('aza:diy-motor'));

  labs.forEach(start);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-aza-diy-lab]').forEach(init);
  });
})();
